/* tslint:disable */
/* eslint-disable */
//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.15.7.0 (NJsonSchema v10.6.7.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------
// ReSharper disable InconsistentNaming
// @ts-nocheck



export interface AuftragHeader {
    id?: string | undefined;
    key?: string | undefined;
    auftragsnummer?: number;
    modificationDate?: string;
    version?: number;
    Auftragsstatus?: number;
    Auftragstyp?: Auftragstyp;
    GeraeteNummer?: string | undefined;
    PersonalKey?: string | undefined;
    OberAuftragKey?: string | undefined;
}

export enum Auftragstyp {
    Unbekannt = 0,
    Transportauftrag = 1,
    Hofchecker = 2,
    Kommissionierung = 3,
    Wareneingang = 4,
    Alle = 999,
}

export interface SaveResult {
    success?: boolean;
    message?: string | undefined;
    id?: string | undefined;
    entity?: any | undefined;
}

export interface AppAuftragZuweisenRequest {
    Key?: string | undefined;
    Zuweisen?: boolean;
}

export interface AuftragDto {
    id?: string | undefined;
    key?: string | undefined;
    auftragsnummer?: number;
    auftrag?: string | undefined;
    version?: number;
    NichtFuerGeraet?: boolean | undefined;
}

export interface DownloadAuftraegeRequest {
    IDs?: string[] | undefined;
}

export interface WebFehlendeTypen {
    dataTableModel?: DataTableModel | undefined;
    auftragDataTableModel?: AuftragDataTableModel | undefined;
    protokollDataTableModel?: ProtokollDataTableModel | undefined;
    geraeteDataTableModel?: GeraeteDataTableModel | undefined;
    verlaufDataTableModel?: VerlaufDataTableModel | undefined;
    geraetStatusVerlauf?: GeraetStatusVerlauf | undefined;
    werkstattFehlermeldung?: WerkstattFehlermeldung | undefined;
    werkstattDataTableModel?: WerkstattDataTableModel | undefined;
}

export interface DataTableModel {
    Suchtext?: string | undefined;
    draw?: number;
    start?: number;
    length?: number;
    columns?: DataTableColumn[] | undefined;
    order?: DataTableOrder[] | undefined;
    search?: DataTableSearch | undefined;
    filter?: DataTableFilterEntry[] | undefined;
    isExcelExport?: boolean;
    FilterJson?: string | undefined;
    DatumVon?: string | undefined;
    DatumBis?: string | undefined;
    AdresseKey?: string | undefined;
    Anlage?: string | undefined;
    SelectedKeys?: string[] | undefined;
    SonderFilter?: string | undefined;
    CustomValues?: { [key: string]: any; } | undefined;
    CustomFilters?: { [key: string]: string; } | undefined;
    columnSearchMap?: { [key: string]: string; } | undefined;
}

export interface DataTableColumn {
    data?: string | undefined;
    name?: string | undefined;
    search?: DataTableSearch | undefined;
}

export interface DataTableSearch {
    value?: string | undefined;
}

export interface DataTableOrder {
    columnName?: string | undefined;
    dir?: string | undefined;
}

export interface DataTableFilterEntry {
    name?: string | undefined;
    from?: string | undefined;
    to?: string | undefined;
}

export interface AuftragDataTableModel extends DataTableModel {
    datumFilter?: string | undefined;
    DatumVon?: string | undefined;
    DatumBis?: string | undefined;
    Dispokategorien?: string[] | undefined;
    UnterMandanten?: string[] | undefined;
    statusFilter?: string | undefined;
    geraeteNummern?: string[] | undefined;
    IncludePositionenText?: boolean;
    IncludeDispoDaten?: boolean;
}

export interface ProtokollDataTableModel extends DataTableModel {
    datumFilter?: string | undefined;
    datumVon?: string | undefined;
    datumBis?: string | undefined;
    typFilter?: string | undefined;
}

export interface GeraeteDataTableModel extends DataTableModel {
    geraeteGruppen?: string[] | undefined;
}

export interface VerlaufDataTableModel extends DataTableModel {
    GeraeteNummer?: string | undefined;
    Datum?: string | undefined;
}

export interface DefaultEntity {
    id?: string | undefined;
    CreationDate?: string;
    ModificationDate?: string;
    LastAccess?: string | undefined;
    modificationServer?: string | undefined;
}

export interface GeraetStatusVerlauf extends DefaultEntity {
    GeraeteNummer?: string | undefined;
    Timestamp?: string;
    GeraeteKey1?: string | undefined;
    Datum?: string | undefined;
    Start?: string | undefined;
    Ende?: string | undefined;
    Status?: string | undefined;
    Typ?: GeraetStatusVerlaufTyp;
    Dauer?: number | undefined;
    DauerInfo?: string | undefined;
    Kmh?: number | undefined;
    Position?: GeoPosition | undefined;
    MinLat?: number | undefined;
    MaxLat?: number | undefined;
    MinLon?: number | undefined;
    MaxLon?: number | undefined;
    PersonalKey?: string | undefined;
    AuftragKey?: string | undefined;
    FahrzeugKey?: string | undefined;
    Fahrzeug?: string | undefined;
    TourKey?: string | undefined;
    LKZ?: string | undefined;
    PLZ?: string | undefined;
    Ort?: string | undefined;
    Strasse?: string | undefined;
    OrtInfo?: string | undefined;
    TelematikTyp?: TelematikStatusTyp | undefined;
}

export enum GeraetStatusVerlaufTyp {
    Standard = 0,
    Telematik = 1,
    Statusmeldung = 2,
    Diagnosedaten = 3,
    Anmelden = 4,
    Abmelden = 5,
    Navigation = 6,
    TourStart = 7,
    TourEnde = 8,
}

export interface GeoPosition {
    t?: number;
    a?: number;
    b?: number;
    c?: number | undefined;
    u?: number | undefined;
    v?: number | undefined;
    w?: number | undefined;
    p?: string | undefined;
    z?: number;
    d?: number;
    typ?: PositionsTyp | undefined;
    zusatzdaten?: { [key: string]: any; } | undefined;
}

export enum PositionsTyp {
    Standard = 0,
    Statusmeldung = 1,
    Anmeldung = 2,
    BehaelterScan = 3,
    Unterschrift = 4,
    Nachricht = 5,
    Tour = 6,
    Uvv = 7,
    Lesebestaetigung = 8,
}

export enum TelematikStatusTyp {
    Unbekannt = 0,
    Fahren = 1,
    Halten = 2,
    Parken = 3,
}

export interface WerkstattFehlermeldung extends DefaultEntity {
    MandantName?: string | undefined;
    AngelegtAm?: string;
    Datum?: string;
    FahrzeugKennzeichen?: string | undefined;
    FahrzeugKey?: string | undefined;
    PersonalKey?: string | undefined;
    PersonalName?: string | undefined;
    Personalnummer?: string | undefined;
    Key?: string | undefined;
    Name?: string | undefined;
    Status?: string | undefined;
    Anmerkungen?: string | undefined;
    GeraeteNummer?: string | undefined;
    GeraeteBezeichnung?: string | undefined;
    Bilder?: ReCoMobilBild[] | undefined;
    otherData?: { [key: string]: any; } | undefined;
}

export interface ReCoMobilBild {
    Datum?: string | undefined;
    BildGuid?: string | undefined;
    Bild?: string | undefined;
    Typ?: string | undefined;
    Bezeichnung?: string | undefined;
    Position?: GpsPosition | undefined;
    FuerVeterinaer?: boolean;
    Metadata?: { [key: string]: string; } | undefined;
}

export interface GpsPosition {
    Timestamp?: number;
    Latitude?: number;
    Longitude?: number;
    Altitude?: number | undefined;
    Accuracy?: number | undefined;
    Speed?: number | undefined;
    Bearing?: number | undefined;
}

export interface WerkstattDataTableModel extends DataTableModel {
    Status?: string[] | undefined;
    FahrzeugGruppen?: string[] | undefined;
    FahrzeugKeys?: string[] | undefined;
}

export interface CheckUpdatesResult {
    errorMessage?: string | undefined;
    updateVerfuegbar?: boolean;
    updateVersion?: string | undefined;
    releaseNotes?: string | undefined;
}

export interface LoginResult {
    permissions?: Permission[] | undefined;
    success?: boolean;
    message?: string | undefined;
    token?: string | undefined;
    user?: UserDto | undefined;
    mandant?: Mandant | undefined;
    mandantBenutzer?: MandantBenutzer | undefined;
}

export enum Permission {
    None = 0,
    ShowUsers = 1,
    EditUsers = 2,
    ShowGeraete = 3,
    EditGeraete = 4,
    ReadGeraete = 5,
    CreateDemandRequest = 9,
    ShowUserRoles = 10,
    EditUserRoles = 11,
    Administration = 12,
    ReadAuftrag = 22,
    ListAuftraege = 23,
    ProtokollAnzeigen = 24,
    ProtokollBearbeiten = 25,
    KarteAnzeigen = 26,
    WorkflowsAnzeigen = 27,
    WorkflowsBearbeiten = 28,
    FahrerBearbeiten = 29,
    FahrerAnzeigen = 30,
    FahrzeugBearbeiten = 31,
    FahrzeugAnzeigen = 32,
    ArtikelAnzeigen = 33,
    ArtikelBearbeiten = 34,
    UvvKatalogAnzeigen = 35,
    UvvKatalogBearbeiten = 36,
    AbfahrtskontrolleKatalogAnzeigen = 37,
    AbfahrtskontrolleKatalogBearbeiten = 38,
    FormulareBearbeiten = 39,
    UvvPruefungenAnzeigen = 40,
    UvvPruefungenBearbeiten = 41,
    UvvPruefGegenstaendeAnzeigen = 42,
    UvvPruefGegenstaendeBearbeiten = 43,
    ChecklisteBearbeiten = 44,
    ChecklisteAnzeigen = 45,
    DokumenteAnzeigen = 46,
    DokumenteBearbeiten = 47,
    DruckformulareAnzeigen = 48,
    DruckformulareBearbeiten = 49,
    ArtikelgruppenAnzeigen = 50,
    ArtikelgruppenBearbeiten = 51,
    FahrzeuggruppenAnzeigen = 52,
    FahrzeuggruppenBearbeiten = 53,
    GeraetegruppenAnzeigen = 54,
    GeraetegruppenBearbeiten = 55,
    StatuszusatzinfoAnzeigen = 56,
    StatuszusatzinfoBearbeiten = 57,
    Nachrichten = 58,
    AdresseAnzeigen = 59,
    AdresseBearbeiten = 60,
    WaageAnzeigen = 61,
    WaageBearbeiten = 62,
    Tabellenkonfiguration = 63,
    EditGeraeteEinfacheDaten = 64,
    AuftraegeBearbeiten = 65,
    AuftraegeLoeschen = 66,
    GastzugangAnzeigen = 67,
    GastzugangBearbeiten = 68,
    Dashboard = 69,
    StoerzeitAnzeigen = 70,
    StoerzeitBearbeiten = 71,
    TourenAnzeigen = 72,
    TourenBearbeiten = 73,
    Tourenplanung = 74,
    StammtourAnzeigen = 75,
    StammtourBearbeiten = 76,
    Auswertungen = 77,
    AbfahrtskontrolleAnzeigen = 78,
    AbfahrtskontrolleBearbeiten = 79,
    TexteAnzeigen = 80,
    TexteBearbeiten = 81,
    VertraegeAnzeigen = 82,
    VertraegeBearbeiten = 83,
    ZeiterfassungAnzeigen = 84,
    ZeiterfassungBearbeiten = 85,
    Benachrichtigungen = 86,
    BerichteAnzeigen = 87,
    BerichteBearbeiten = 88,
    NVEAnzeigen = 89,
    NVEBearbeiten = 90,
    GlasAnalyseAnzeigen = 91,
    GlasAnalyseBearbeiten = 92,
    GlasAnalyseKonfiguration = 93,
    Kalender = 94,
    RegelAnzeigen = 95,
    RegelBearbeiten = 96,
    GeraetegruppenBearbeitenEinfacheDaten = 97,
    Werkstattuebersicht = 98,
    ListTouren = 99,
    EditTouren = 100,
    Kostenstellen = 101,
    EinstellungenKunde = 102,
    Sysadmin = 999,
}

export interface DefaultDTO {
    id?: string | undefined;
    creationDate?: string | undefined;
    modificationDate?: string | undefined;
}

export interface UserDto extends DefaultDTO {
    username?: string | undefined;
    anrede?: string | undefined;
    vorname?: string | undefined;
    name?: string | undefined;
    token?: string | undefined;
    email?: string | undefined;
    isSysadmin?: boolean;
    roles?: string[] | undefined;
    welcomeMail?: boolean;
    fullName?: string | undefined;
    newEmail?: string | undefined;
    displayName?: string | undefined;
    isAendernErlaubt?: boolean;
    PasswortAendern?: boolean;
    newPassword?: string | undefined;
    Konfigurationen?: BenutzerKonfiguration[] | undefined;
    Einstellungen?: { [key: string]: any; } | undefined;
}

export interface BenutzerKonfiguration {
    Key?: string | undefined;
    Value?: string | undefined;
}

export interface Mandant extends DefaultEntity {
    name?: string | undefined;
    beschreibung?: string | undefined;
    appPasswort?: string | undefined;
    apiToken?: string | undefined;
    einstellungen?: { [key: string]: string; } | undefined;
    formulare?: MandantFormulare | undefined;
    tabellenKonfigurationen?: { [key: string]: MandantTabellenkonfiguration; } | undefined;
    formularKonfiguration?: { [key: string]: any; } | undefined;
    ArbeitszeitKonfiguration?: ArbeitszeitKonfiguration | undefined;
    StoerzeitKonfiguration?: StoerzeitKonfiguration | undefined;
    InterneDaten?: MandantInterneDaten | undefined;
    UnterMandanten?: UnterMandant[] | undefined;
    GlasAnalyse?: GlasAnalyseEinstellungen | undefined;
    Benachrichtigungen?: MandantBenachrichtigungen | undefined;
}

export interface MandantFormulare {
    abfahrtskontrolle?: AbfahrtskontrolleFormular | undefined;
    transportauftrag?: AuftragsFormular | undefined;
    hofauftrag?: AuftragsFormular | undefined;
    kommissionierung?: AuftragsFormular | undefined;
}

export interface AbfahrtskontrolleFormular {
    Gruppieren?: boolean;
    Gruppen?: AbfahrtskontrolleGruppe[] | undefined;
    eintraege?: AbfahrtskontrolleEintrag[] | undefined;
}

export interface AbfahrtskontrolleGruppe {
    Id?: string | undefined;
    Name?: string | undefined;
    Infotext?: string | undefined;
    Sort?: number;
    Deaktiviert?: boolean;
}

export interface AbfahrtskontrolleEintrag {
    sort?: number;
    key?: string | undefined;
    name?: string | undefined;
    Typ?: string | undefined;
    beschreibungPflicht?: boolean | undefined;
    fotoPflicht?: boolean | undefined;
    Beschreibung?: string | undefined;
    Gruppe?: string | undefined;
    Foto?: string | undefined;
    Intervall?: number;
    IntervallTyp?: string | undefined;
}

export interface AuftragsFormular {
    komponenten?: AuftragsKomponente[] | undefined;
}

export interface AuftragsKomponente {
    name?: string | undefined;
    sort?: number | undefined;
    einstellungen?: FormularEinstellung[] | undefined;
}

export interface FormularEinstellung {
    key?: string | undefined;
    wert?: string | undefined;
}

export interface MandantTabellenkonfiguration {
    tableKey?: string | undefined;
    stateJson?: string | undefined;
    angelegtVon?: string | undefined;
    datum?: number;
}

export interface ArbeitszeitKonfiguration {
    Warnungen?: Arbeitszeitwarnung[] | undefined;
    AuftragArbeitszeitArten?: ArbeitsartKonfiguration[] | undefined;
}

export interface Arbeitszeitwarnung {
    Key?: string | undefined;
    Zeit?: number | undefined;
    MeldungText?: string | undefined;
    Intervall?: number | undefined;
}

export interface ArbeitsartKonfiguration {
    Key?: string | undefined;
    Name?: string | undefined;
    Referenz?: string | undefined;
    Standard?: boolean;
    Sort?: number;
    BemerkungPflicht?: boolean;
}

export interface StoerzeitKonfiguration {
    Stoerzeiten?: StoerzeitDefinition[] | undefined;
}

export interface StoerzeitDefinition {
    Id?: string | undefined;
    Name?: string | undefined;
    Key?: string | undefined;
    Typ?: string | undefined;
    StandardDauer?: number | undefined;
    Sort?: number;
    BemerkungPflicht?: boolean;
}

export interface MandantInterneDaten {
    AbrechnungAktiv?: boolean;
    PreisGeraetJeMonat?: number | undefined;
    PreisGeraetEinmalig?: number | undefined;
    Abrechnungsintervall?: MandantAbrechnungsintervall;
    Rechnungsdatum?: string | undefined;
    MaxGeraete?: number | undefined;
    MaxBenutzer?: number | undefined;
}

export enum MandantAbrechnungsintervall {
    Monatlich = 0,
    Quartalsweise = 1,
    Jaehrlich = 2,
}

export interface UnterMandant {
    Name?: string | undefined;
}

export interface GlasAnalyseEinstellungen {
    Anlagen?: GlasAnalyseAnlage[] | undefined;
    MaterialListe?: GlasAnalyseMaterial[] | undefined;
    Grenzwerte?: GlasAnalyseGrenzwert[] | undefined;
    Meldungen?: GlasAnalyseMeldung[] | undefined;
    StoerungGruende?: GlasAnalyseStoerungGrund[] | undefined;
    Abhilfemassnahmen?: GlasAnalyseAbhilfemassnahmen[] | undefined;
}

export interface KeyNameItem {
    Key?: string | undefined;
    Name?: string | undefined;
}

export interface GlasAnalyseAnlage extends KeyNameItem {
    SiebprobeUhrzeiten?: string | undefined;
    FehlfarbenUhrzeiten?: string | undefined;
    BettascheUhrzeiten?: string | undefined;
    Arbeitsplan?: string | undefined;
}

export interface GlasAnalyseMaterial extends KeyNameItem {
    Config?: string | undefined;
    Anlagen?: string | undefined;
}

export interface GlasAnalyseGrenzwert {
    Key?: string | undefined;
    Name?: string | undefined;
    Material?: string | undefined;
    Mittelwert?: number | undefined;
    Ablehnung?: number | undefined;
}

export interface GlasAnalyseMeldung {
    Key?: string | undefined;
    MeldungText?: string | undefined;
    Intervall?: number | undefined;
    Typ?: string | undefined;
}

export interface GlasAnalyseStoerungGrund extends KeyNameItem {
}

export interface GlasAnalyseAbhilfemassnahmen extends KeyNameItem {
    Grenzwert?: string | undefined;
    Material?: string | undefined;
    ZweiteProbeErforderlich?: boolean;
}

export interface MandantBenachrichtigungen {
    Fuehrerscheinkontrolle?: BenachrichtigungItem[] | undefined;
    Glasanalyse?: BenachrichtigungItem[] | undefined;
    Abfahrtskontrolle?: BenachrichtigungItem[] | undefined;
    Unfallbericht?: BenachrichtigungItem[] | undefined;
    Urlaubsantrag?: BenachrichtigungItem[] | undefined;
    Taetigkeitsbericht?: BenachrichtigungItem[] | undefined;
    Tankbericht?: BenachrichtigungItem[] | undefined;
    Maengelbericht?: BenachrichtigungItem[] | undefined;
    Hofdokumentation?: BenachrichtigungItem[] | undefined;
    UvvHinweisMeldung?: BenachrichtigungItem[] | undefined;
    UvvPruefungMeldung?: BenachrichtigungItem[] | undefined;
}

export interface BenachrichtigungItem {
    Key?: string | undefined;
    UnterMandant?: string | undefined;
    Bedingung?: string | undefined;
    Email?: string | undefined;
}

export interface MandantBenutzer extends DefaultEntity {
    benutzerId?: string | undefined;
    mandantId?: string | undefined;
    email?: string | undefined;
    benutzername?: string | undefined;
    anrede?: string | undefined;
    vorname?: string | undefined;
    name?: string | undefined;
    anzeigename?: string | undefined;
    lastLogin?: string | undefined;
    status?: MandantZuordnungStatus;
    gesperrt?: boolean;
    letzteVerwendung?: string;
    roles?: string[] | undefined;
    Konfigurationen?: BenutzerKonfiguration[] | undefined;
    Einstellungen?: { [key: string]: any; } | undefined;
}

export enum MandantZuordnungStatus {
    Anfrage = 0,
    Inhaber = 1,
    Aktiv = 2,
    Abgelehnt = 3,
}

export interface LoginRequest {
    user?: string | undefined;
    password?: string | undefined;
    rememberMe?: boolean;
    mandant?: string | undefined;
}

export interface WechsleMandantRequest {
    mandantId?: string | undefined;
}

export interface Abrechnungsdaten {
    monatsdaten?: MandantAbrechnung[] | undefined;
}

export interface MandantAbrechnung {
    datum?: string;
    mandantName?: string | undefined;
    anzahlGeraete?: number;
    anzahlAbrechnungGeraete?: number;
    anzahlInaktiveGeraete?: number;
    anzahlVerwendeterNichtAbgerechneterGeraete?: number;
    summe?: number;
    summeGeraetelizenzen?: number;
    summeEinmalig?: number;
    abrechnungMonate?: number;
    anzahlEinmaligGeraete?: number;
}

export interface AbrechnungsdatenFilter {
    datumVon?: string | undefined;
    datumBis?: string | undefined;
    mandantName?: string | undefined;
}

export interface MandantStatistik {
    mandant?: Mandant | undefined;
    restSchnittstelleAktiv?: boolean;
    geraete?: GeraetDto[] | undefined;
    auftragsdaten?: AuftragsdatenStatistik | undefined;
    geraetegruppen?: Geraetegruppe[] | undefined;
}

export interface GeraetDto extends DefaultDTO {
    MandantName?: string | undefined;
    GeraeteNummer?: string | undefined;
    Bezeichnung?: string | undefined;
    BezeichnungText?: string | undefined;
    GeraeteGruppe?: string | undefined;
    Passwort?: string | undefined;
    Farbe?: string | undefined;
    Gesperrt?: boolean;
    NewPassword?: string | undefined;
    TrafficAktuellerMonat?: string | undefined;
    EinstellungenAnpassen?: boolean;
    UnterMandant?: string | undefined;
    Symbol?: string | undefined;
    Icon128?: string | undefined;
    Icon64?: string | undefined;
    ErsteVerwendung?: string | undefined;
    LetzteVerwendung?: string | undefined;
    InterneDaten?: GeraetInterneDaten | undefined;
    einstellungen?: { [key: string]: string; } | undefined;
    GeraetStatus?: GeraetStatus | undefined;
    statistik?: GeraeteStatistik[] | undefined;
    LetzteAbmeldung?: string | undefined;
    LetzteAnmeldung?: string | undefined;
    IstAngemeldet?: boolean | undefined;
    Telefonnummer?: string | undefined;
    EMailAdresse?: string | undefined;
    Freitext?: string | undefined;
    DeviceInfo?: { [key: string]: string; } | undefined;
    Anlagen?: string[] | undefined;
    AnlagenInfo?: string | undefined;
}

export interface GeraetInterneDaten {
    AbrechnungAb?: string | undefined;
    AbrechnungBis?: string | undefined;
    PreisJeMonat?: number | undefined;
    PreisEinmalig?: number | undefined;
    Testgeraet?: boolean;
}

export interface GeraetStatus extends DefaultEntity {
    Key?: string | undefined;
    GeraeteNummer?: string | undefined;
    AppVersion?: string | undefined;
    OsVersion?: string | undefined;
    PersonalKey?: string | undefined;
    Personalnummer?: string | undefined;
    PersonalName?: string | undefined;
    FahrzeugKey?: string | undefined;
    FahrzeugKennzeichen?: string | undefined;
    LetzterPersonalName?: string | undefined;
    LetzterFahrzeugKey?: string | undefined;
    LetztesFahrzeugKennzeichen?: string | undefined;
    AnhaengerKey?: string | undefined;
    AnhaengerKennzeichen?: string | undefined;
    LetzteNachrichtText?: string | undefined;
    AnzahlNichtGeleseneNachrichten?: number | undefined;
    AnzahlErledigteAuftraege?: number | undefined;
    AnzahlAbgelehntAuftraege?: number | undefined;
    AktivSeit?: string | undefined;
    letzteNachrichtDatum?: string | undefined;
    trafficMonat?: string | undefined;
    trafficAktuellerMonat?: number;
    istWebSocketVerbunden?: boolean | undefined;
    webSocketServerName?: string | undefined;
    letztePositionen?: GeoPosition[] | undefined;
    LetztePosition?: GeoPosition | undefined;
    Fahrtrichtung?: number | undefined;
    TelematikStatus?: TelematikStatusTyp | undefined;
    ZuletztOnline?: string | undefined;
    AktuellerAuftrag?: Auftrag | undefined;
    AktuellerAuftragDatum?: string | undefined;
    NavigationsAdresse?: Adresse | undefined;
    NavigationsAdresseEntfernung?: number | undefined;
    otherData?: { [key: string]: any; } | undefined;
    IstOnline?: boolean | undefined;
    AktuellAnzahlAuftraegeOffen?: number | undefined;
    AktuellAnzahlAuftraegeErledigt?: number | undefined;
    AktuellAnzahlAuftraegeAbgelehnt?: number | undefined;
    AnzahlAuftraegeDirty?: boolean | undefined;
    UvvSchnellpruefungZugriffe?: number | undefined;
    AnzahlAuftraegeLetzteAktualisierung?: string | undefined;
    LetzteWiegungFahrzeug?: WiegungInfoRef | undefined;
    LetzteWiegungAnhaenger?: WiegungInfoRef | undefined;
    AktuellesGewicht?: number | undefined;
}

export interface Auftrag {
    Key?: string | undefined;
    OberAuftragKey?: string | undefined;
    TourKey?: string | undefined;
    AbsenderSystem?: string | undefined;
    Statuszeit?: string | undefined;
    Auftragsstatus?: number;
    IstNeuanlage?: boolean | undefined;
    Statusmeldung?: string | undefined;
    StatusmeldungKey?: string | undefined;
    StatusmeldungZusatzinfo?: StatusmeldungZusatzinfo | undefined;
    Auftragsnummer?: number;
    Reihenfolge?: number;
    Geraet?: string | undefined;
    GeraeteGruppe?: string | undefined;
    PersonalKey?: string | undefined;
    Personalnummer?: string | undefined;
    BeifahrerKey?: string | undefined;
    BeifahrerKey2?: string | undefined;
    Fahrzeug?: string | undefined;
    FahrzeugKey?: string | undefined;
    Anhaenger?: string | undefined;
    AnhaengerKey?: string | undefined;
    Barcode?: string | undefined;
    Auftragstyp?: Auftragstyp;
    Mandant?: string | undefined;
    UnterMandant?: string | undefined;
    AAbholdatum?: string | undefined;
    AAbholzeitVon?: string | undefined;
    AAbholzeitBis?: string | undefined;
    AErfasser?: string | undefined;
    Abholadresse?: Adresse | undefined;
    Abholadresse2?: Adresse | undefined;
    Erzeugeradresse?: Adresse | undefined;
    Verwerteradresse?: Adresse | undefined;
    Befoerdereradresse?: Adresse | undefined;
    AAbladedatum?: string | undefined;
    AAbladezeitVon?: string | undefined;
    AAbladezeitBis?: string | undefined;
    AbholzeitText?: string | undefined;
    AHaupflaufContNr?: string | undefined;
    /** Externe Auftragsnummer. Wird vom Fahrer über die Formular-Komponente "Ext-Nummer" erfasst und beim Import nach Auftragskopf.AextNummer übernommen. */
    AextNummer?: string | undefined;
    GeplanteDauer?: number | undefined;
    Positionen?: Auftragsposition[] | undefined;
    RetourPositionen?: Auftragsposition[] | undefined;
    /** Vom Fahrer gelöschte Positionen, die ReCoLog bereits kennt (Einstellung "Positionen löschen erlaubt"). ReCoLog löscht sie beim Import und vermerkt das in der Statusverfolgung. */
    GeloeschtePositionen?: Auftragsposition[] | undefined;
    Hinweistexte?: Hinweistext[] | undefined;
    Anlagen?: ReCoMobilDokument[] | undefined;
    Kilomterstand?: number | undefined;
    GeoposGeraetX?: number | undefined;
    GeoposGeraetY?: number | undefined;
    Quittungsname?: string | undefined;
    Quittungsbild?: string | undefined;
    QuittungsbildGuid?: string | undefined;
    Bilder?: ReCoMobilBild[] | undefined;
    Auftragsbilder?: ReCoMobilBild[] | undefined;
    Unterschriften?: Unterschrift[] | undefined;
    UnterschriftKundeErforderlich?: boolean | undefined;
    /** Abholadresse, Kunde oder eine abweichende Abholadresse der Positionen hat in ReCoLog "Druck auf App aktiv". Siehe AuftragHelper.istPflichtdruckErforderlich(). */
    DruckErforderlich?: boolean | undefined;
    /** Wird gesetzt, wenn ein Auftrag mit Pflichtdruck ohne Druck abgeschlossen wurde. Enthält den Grund, ReCoLog protokolliert ihn im VarStatus. */
    DruckUebersprungen?: string | undefined;
    WorkflowName?: string | undefined;
    Anmerkungen?: string | undefined;
    UnterschriftText?: string | undefined;
    FahrzeugKennung?: string | undefined;
    FahrzeugKennung2?: string | undefined;
    FahrzeugKennung3?: string | undefined;
    Info1?: string | undefined;
    Info2?: string | undefined;
    Info3?: string | undefined;
    Info4?: string | undefined;
    Info5?: string | undefined;
    DetailInfo1?: string | undefined;
    DetailInfo2?: string | undefined;
    DetailInfo3?: string | undefined;
    ChecklistenVorgabe?: ChecklisteVorgabe[] | undefined;
    ChecklistenErgebnis?: ChecklisteErgebnis[] | undefined;
    Kontakte?: Kontakt[] | undefined;
    DruckFormularName?: string | undefined;
    DruckFormularDaten?: string | undefined;
    DruckFormularDatenPdf?: string | undefined;
    IstBezahlt?: boolean | undefined;
    BezahlungBetrag?: number | undefined;
    BezahlungArt?: BezahlartTyp | undefined;
    SummeBrutto?: number | undefined;
    SummeNetto?: number | undefined;
    SummeMwst?: number | undefined;
    PreiseGueltig?: boolean | undefined;
    MwstBetraege?: MwstBetragEintrag[] | undefined;
    Vertraege?: AuftragVertrag[] | undefined;
    LoescheAlleUnterauftraege?: boolean | undefined;
    ATOGesamtgewichtKG?: number | undefined;
    ATOGesamtvolumenLtr?: number | undefined;
    ATOGesamtstellplatz?: number | undefined;
    ATOStandZeitInMinuten?: number | undefined;
    ATOLieferzeitfensterBeginn?: string | undefined;
    ATOLieferzeitfensterEnde?: string | undefined;
    ATOFahrzeugFix?: boolean | undefined;
    ATOStatus?: string | undefined;
    Dispokategorie?: string | undefined;
    Stammtour?: string | undefined;
    GruppeKey?: string | undefined;
    GruppeBezeichnung?: string | undefined;
    Zusatzdaten?: { [key: string]: string; } | undefined;
    Stoerzeiten?: Stoerzeit[] | undefined;
    Lieferungen?: Auftrag[] | undefined;
    Icon?: string | undefined;
    Protokoll?: ProtokollEintrag[] | undefined;
    UnterauftragKeys?: string[] | undefined;
    Ladeplan?: ReCoMobilLadeplan | undefined;
    Zeiten?: ZeitEintrag[] | undefined;
    ERPStatus?: string | undefined;
    ERPStatusFarbe?: string | undefined;
    ExternesSystemName?: string | undefined;
    Farbe?: string | undefined;
    WiegungErfolgreich?: boolean | undefined;
    otherData?: { [key: string]: any; } | undefined;
}

export interface StatusmeldungZusatzinfo {
    Felder?: StatusFeldWert[] | undefined;
}

export interface StatusFeldWert {
    Key?: string | undefined;
    Bezeichnung?: string | undefined;
    Wert?: string | undefined;
}

export interface Adresse {
    AdressNummer?: string | undefined;
    Name1?: string | undefined;
    Name2?: string | undefined;
    Name3?: string | undefined;
    BehoerdlicheNummer?: string | undefined;
    Strasse?: string | undefined;
    PLZ?: string | undefined;
    Ort?: string | undefined;
    LKZ?: string | undefined;
    Telefon?: string | undefined;
    Ansprechpartner?: string | undefined;
    GeoX?: number | undefined;
    GeoY?: number | undefined;
    Entfernung?: number | undefined;
    GeocodingLongitude?: number | undefined;
    GeocodingLatitude?: number | undefined;
    PortalPwd?: string | undefined;
    LieferscheinEmail?: string | undefined;
    LieferscheinEmailNeu?: string | undefined;
    Zusatzdaten?: { [key: string]: string; } | undefined;
    otherData?: { [key: string]: any; } | undefined;
}

export interface Auftragsposition {
    PosNr?: number;
    ArtikelKey?: string | undefined;
    Bezeichnung?: string | undefined;
    Bezeichnung2?: string | undefined;
    SprachText?: string | undefined;
    Menge?: number | undefined;
    MengeSoll?: number | undefined;
    MengeIst?: number | undefined;
    StandardMenge?: number | undefined;
    MengeOption?: MengeOptionTyp;
    Einheit?: string | undefined;
    EinzelVK?: number | undefined;
    NettoBetrag?: number | undefined;
    Brutto?: number | undefined;
    MwstSatz?: number | undefined;
    MwstBetrag?: number | undefined;
    GewichtInKg?: number | undefined;
    GewichtInKgAktiv?: boolean | undefined;
    GewichtInKgPflicht?: boolean | undefined;
    BhAktion?: string | undefined;
    Eigenschaften?: ReCoMobilEigenschaft[] | undefined;
    Positionsbilder?: ReCoMobilBild[] | undefined;
    Behaelter?: ReCoMobilBehaelterbewegung[] | undefined;
    Elemente?: ReCoMobilElement[] | undefined;
    Anmerkungen?: string | undefined;
    IstNeu?: boolean;
    IstGesendet?: boolean | undefined;
    /** Nur in Auftrag.GeloeschtePositionen: Zeitpunkt, zu dem der Fahrer die Position gelöscht hat. */
    GeloeschtAm?: string | undefined;
    /** Nur in Auftrag.GeloeschtePositionen: Name und Personalnummer des Fahrers. */
    GeloeschtVon?: string | undefined;
    Vertragsnummer?: string | undefined;
    Vertragsposition?: number | undefined;
    Wiegungen?: Wiegedaten[] | undefined;
    Wiegungen2?: AuftragspositionWiegung[] | undefined;
    MinAnzahlBilder?: number | undefined;
    /** "Druck aktiv" des Artikels in ReCoLog. Der Auftrag muss vor dem Abschließen gedruckt werden (nur bei Menge > 0). */
    DruckErforderlich?: boolean | undefined;
    LaderaumAuswahlAktiv?: boolean | undefined;
    Laderaum?: string | undefined;
    LaderaumNummer?: number | undefined;
    AuftragWiegungAktiv?: boolean | undefined;
    LPN?: string | undefined;
    Charge?: string | undefined;
    Chargen?: ReCoMobilCharge[] | undefined;
    GTIN?: string | undefined;
    NVE?: string | undefined;
    SeriennummerErforderlich?: boolean | undefined;
    ArtikelDarfGeaendertWerden?: boolean | undefined;
    ArtikelWurdeGeaendert?: boolean | undefined;
    Chargenpflicht?: boolean | undefined;
    APosId?: number | undefined;
    otherData?: { [key: string]: any; } | undefined;
}

export enum MengeOptionTyp {
    Aenderbar = 0,
    StandardOderNull = 1,
    NichtAenderbar = 2,
    AenderbarGroesserNull = 3,
}

export interface ReCoMobilEigenschaft {
    Key?: string | undefined;
    Bezeichnung?: string | undefined;
    Wert?: string | undefined;
    Typ?: string | undefined;
    Regex?: string | undefined;
    Uppercase?: boolean | undefined;
    Sortierung?: number;
    Sonderpruefung?: string | undefined;
    otherData?: { [key: string]: any; } | undefined;
}

export interface ReCoMobilBehaelterbewegung {
    BehaelterNr?: string | undefined;
    Aktion?: string | undefined;
    IsScan?: boolean | undefined;
    Abstellort?: string | undefined;
    Zustand?: string | undefined;
    Position?: GpsPosition | undefined;
}

export interface ReCoMobilElement {
    Pos?: number;
    Nummer?: string | undefined;
    Typ?: string | undefined;
}

export interface Wiegedaten {
    Datum?: string | undefined;
    Wiegenummer?: number;
    Wiegenummer2?: number;
    Wiegung1?: number | undefined;
    Wiegung2?: number | undefined;
    Netto?: number | undefined;
    Info?: string | undefined;
}

export interface AuftragspositionWiegung {
    Nummer?: number | undefined;
    Datum?: string | undefined;
    Gewicht?: number | undefined;
    WiegeNr?: string | undefined;
    WaageKey?: string | undefined;
    Einheit?: string | undefined;
    Typ?: WiegungTyp | undefined;
}

export enum WiegungTyp {
    Unbekannt = 0,
    Wiegung = 1,
    Handeingabe = 2,
    Leergewicht = 3,
    Frei4 = 4,
    Frei5 = 5,
    Frei6 = 6,
    Frei7 = 7,
    Frei8 = 8,
    Frei9 = 9,
}

export interface ReCoMobilCharge {
    Pos?: number;
    NVE?: string | undefined;
    Charge?: string | undefined;
    Menge?: number;
    MHD?: string | undefined;
}

export interface Hinweistext {
    Art?: string | undefined;
    Inhalt?: string | undefined;
    otherData?: { [key: string]: any; } | undefined;
}

export interface ReCoMobilDokument {
    Art?: string | undefined;
    DateiTyp?: string | undefined;
    Dateiname?: string | undefined;
    Inhalt?: string | undefined;
    MimeType?: string | undefined;
    Size?: number;
    Verfallsdatum?: string | undefined;
    Lesebestaetigung?: boolean;
    Leseverpflichtung?: boolean;
    UnterMandant?: string | undefined;
}

export interface Unterschrift {
    Datum?: string | undefined;
    Guid?: string | undefined;
    Bild?: string | undefined;
    Typ?: string | undefined;
    Name?: string | undefined;
    Position?: GpsPosition | undefined;
}

export interface ChecklisteVorgabe {
    ChecklisteName?: string | undefined;
}

export interface ChecklisteErgebnis {
    ChecklisteName?: string | undefined;
    Eintraege?: ChecklisteStatus[] | undefined;
    otherData?: { [key: string]: any; } | undefined;
}

export interface ChecklisteStatus {
    Key?: string | undefined;
    Text?: string | undefined;
    Status?: string | undefined;
    Anmerkungen?: string | undefined;
    Bilder?: ReCoMobilBild[] | undefined;
    IsFreitextAusgewaehlt?: boolean | undefined;
    otherData?: { [key: string]: any; } | undefined;
}

export interface Kontakt {
    Name?: string | undefined;
    Telefon?: string | undefined;
    Typ?: string | undefined;
    AdressNummer?: string | undefined;
}

export enum BezahlartTyp {
    Unbekannt = 0,
    Bar = 1,
    EC = 2,
    Storno = 3,
}

export interface MwstBetragEintrag {
    MwstSatz?: number;
    NettoBetrag?: number;
    MwstBetrag?: number;
}

export interface AuftragVertrag {
    Vertragsnummer?: string | undefined;
    Bezeichnung?: string | undefined;
    Text?: string | undefined;
    Positionen?: Vertragsposition[] | undefined;
}

export interface Vertragsposition {
    PosNr?: number;
    ArtikelKey?: string | undefined;
    Bezeichnung?: string | undefined;
    Menge?: number | undefined;
    StandardMenge?: number | undefined;
    MengeOption?: MengeOptionTyp;
    Einheit?: string | undefined;
    EinzelVK?: number | undefined;
    NettoBetrag?: number | undefined;
    Brutto?: number | undefined;
    MwstSatz?: number | undefined;
    MwstBetrag?: number | undefined;
    GewichtInKg?: number | undefined;
    GewichtInKgAktiv?: boolean | undefined;
    GewichtInKgPflicht?: boolean | undefined;
    BhAktion?: string | undefined;
    Eigenschaften?: ReCoMobilEigenschaft[] | undefined;
}

export interface Stoerzeit {
    Guid?: string | undefined;
    ErfassungsDatum?: string | undefined;
    Dauer?: number | undefined;
    Name?: string | undefined;
    Key?: string | undefined;
    Typ?: string | undefined;
    Bemerkung?: string | undefined;
}

export interface ProtokollEintrag {
    Datum?: string | undefined;
    Typ?: string | undefined;
    Text?: string | undefined;
    Info1?: string | undefined;
    Info2?: string | undefined;
    Info3?: string | undefined;
    Info4?: string | undefined;
    Info5?: string | undefined;
    PersonalKey?: string | undefined;
    PersonalName?: string | undefined;
    Personalnummer?: string | undefined;
}

export interface ReCoMobilLadeplan {
    Id?: string | undefined;
    Laderaeume?: ReCoMobilLadeplanLaderaum[] | undefined;
}

export interface ReCoMobilLadeplanLaderaum {
    Nummer?: number;
    Label?: string | undefined;
    Innenlaenge?: number;
    Innenbreite?: number;
    Innenhoehe?: number;
    Packstuecke?: ReCoMobilPackstueck[] | undefined;
}

export interface ReCoMobilPackstueck {
    Id?: string | undefined;
    Label?: string | undefined;
    Stop?: number;
    PosL?: number;
    PosB?: number;
    PosH?: number;
    SizeL?: number;
    SizeB?: number;
    SizeH?: number;
    Gewicht?: number;
    Rotation?: string | undefined;
    Inhalt?: string | undefined;
    Kunde?: string | undefined;
    Farbe?: string | undefined;
}

export interface ZeitEintrag {
    StartDatum?: string | undefined;
    EndDatum?: string | undefined;
    Zuordnung?: ZeitEintragZuordnungTyp;
    Typ?: string | undefined;
    AuftragKey?: string | undefined;
    Auftragsnummer?: number | undefined;
    Bemerkung?: string | undefined;
    Dauer?: number | undefined;
    Guid?: string | undefined;
    ArtKey?: string | undefined;
    ArtName?: string | undefined;
    ArtReferenz?: string | undefined;
    TourKey?: string | undefined;
    TourGuid?: string | undefined;
    IsArchiv?: boolean;
    PersonalKey?: string | undefined;
    BeifahrerKey?: string | undefined;
    BeifahrerKey2?: string | undefined;
    PersonalName?: string | undefined;
    BeifahrerName?: string | undefined;
    BeifahrerName2?: string | undefined;
    Fahrzeug?: string | undefined;
    FahrzeugKey?: string | undefined;
    Anhaenger?: string | undefined;
    AnhaengerKey?: string | undefined;
}

export enum ZeitEintragZuordnungTyp {
    Unbekannt = 0,
    Tour = 1,
    Auftrag = 2,
}

export interface WiegungInfoRef {
    Guid?: string | undefined;
    Gewicht?: number | undefined;
    Datum?: string;
}

export interface GeraeteStatistik extends DefaultEntity {
    datum?: string;
    mandantName?: string | undefined;
    geraeteNummer?: string | undefined;
    AuswertungVersion?: number;
    traffic?: GeraeteStatistikTraffic | undefined;
    AbgeschlosseneAuftraege?: GeraeteAuftragsStatistik | undefined;
    Statusmeldungen?: { [key: string]: number; } | undefined;
    GefahreneKilometerGeschaetzt?: number;
    GefahreneKilometer?: number;
    Fahrzeit?: number;
    Hofzeit?: number;
    AktiverZeitraum?: number;
    ErsteBenutzerAktion?: string | undefined;
    LetzteBenutzerAktion?: string | undefined;
}

export interface GeraeteStatistikTraffic {
    details?: { [key: string]: number; } | undefined;
    gesendetTotal?: number;
    empfaengenTotal?: number;
    SummeMb?: number;
}

export interface GeraeteAuftragsStatistik {
    Transportauftraege?: number;
    Hofauftraege?: number;
    WareneingangAuftraege?: number;
    KommissionierAuftraege?: number;
    AuftragKeys?: string[] | undefined;
}

export interface AuftragsdatenStatistik {
    anzahlJeTag?: AuftragsdatenTagAnzahl[] | undefined;
}

export interface AuftragsdatenTagAnzahl {
    datum?: string | undefined;
    anzahl?: number;
}

export interface Geraetegruppe extends DefaultEntity {
    MandantName?: string | undefined;
    Name?: string | undefined;
    Bezeichnung?: string | undefined;
    Farbe?: string | undefined;
    Symbol?: string | undefined;
    KonfigurationInfo?: string | undefined;
    Einstellungen?: { [key: string]: string; } | undefined;
    ArbeitszeitKonfiguration?: ArbeitszeitKonfiguration | undefined;
    StoerzeitKonfiguration?: StoerzeitKonfiguration | undefined;
    otherData?: { [key: string]: any; } | undefined;
}

export interface AppVersion extends DefaultEntity {
    Version?: number;
    VersionCode?: number;
    PackageName?: string | undefined;
    Name?: string | undefined;
    ReleaseNotes?: string | undefined;
    DataGuid?: string | undefined;
    Dateiname?: string | undefined;
    Freigegeben?: boolean;
}

export interface DataTableResult {
    draw?: number;
    recordsTotal?: number;
    recordsFiltered?: number;
    data?: any[] | undefined;
    error?: string | undefined;
}

export interface DeleteResult {
    success?: boolean;
    message?: string | undefined;
}

export interface UploadFileResult extends SaveResult {
    dataGuid?: string | undefined;
}

export interface Dokument extends DefaultEntity {
    typ?: string | undefined;
    typKey?: string | undefined;
    dateiname?: string | undefined;
    Pfad?: string | undefined;
    mimeType?: string | undefined;
    dataGuid?: string | undefined;
    size?: number;
    Verfallsdatum?: string | undefined;
    Lesebestaetigung?: boolean;
    Leseverpflichtung?: boolean;
    UnterMandant?: string | undefined;
}

export interface Druckformular extends DefaultEntity {
    Name?: string | undefined;
    Typ?: string | undefined;
    Dpmm?: number;
    LabelWidth?: number;
    LabelHeight?: number;
    HomeX?: number;
    HomeY?: number;
    Header?: DruckformularBereich | undefined;
    Details?: DruckformularBereich | undefined;
    Footer?: DruckformularBereich | undefined;
    ZPL?: string | undefined;
    ZplStart?: string | undefined;
    ZplStartPosition?: string | undefined;
    ZplEnde?: string | undefined;
    AusdruckJeArtikelgruppe?: boolean;
    AusdruckJeLieferung?: boolean;
    AusdruckJeArtikel?: boolean;
    AusdruckJeArtikelBedingungsFeld?: string;
    AlleWiegungenDrucken?: boolean;
    AnzahlExemplareStandard?: number | undefined;
    AnzahlExemplareWennBezahlt?: number | undefined;
}

export interface DruckformularBereich {
    Template?: string | undefined;
    Model?: ReportModel | undefined;
    Height?: number;
}

export interface ReportModel {
    ExtraCode?: string | undefined;
    Elements?: ReportElement[] | undefined;
}

export interface ReportElement {
    Typ?: ReportElementType;
    Content?: string | undefined;
    DruckBedingung?: string | undefined;
    X?: number;
    Y?: number;
    Width?: number;
    Height?: number;
    FontSize?: number;
    Font?: string | undefined;
    FontWeight?: any | undefined;
    LineHeight?: number;
    TextAlign?: TextAlignType;
    FontStyle?: FontStyleType;
    BorderThickness?: number;
    LineColor?: string | undefined;
    CornerRounding?: number;
    ModuleWidth?: number;
    BarcodeType?: BarcodeType | undefined;
    Orientation?: string | undefined;
    CheckDigit?: string | undefined;
    PrintInterpolationLine?: string | undefined;
    PrintInterpolationLineAboveCode?: string | undefined;
    ImageData?: string | undefined;
    RemoveLineWhenBlank?: boolean;
    QrCodeWidth?: number;
    QrCodeHeight?: number;
    QrCodeWidthRatio?: number | undefined;
    CustomCode?: string | undefined;
}

export enum ReportElementType {
    Text = 0,
    Textblock = 1,
    Image = 2,
    Barcode = 3,
    Rect = 4,
}

export enum TextAlignType {
    Left = 0,
    Center = 1,
    Right = 2,
    Justified = 3,
}

export enum FontStyleType {
    Normal = 0,
    Fett = 1,
    Kursiv = 2,
    Unterstrichen = 3,
    FettUnterstrichen = 4,
    KursivUnterstrichen = 5,
    FettKursiv = 6,
}

export enum BarcodeType {
    Default = 0,
    Code11 = 1,
    Interleaved2of5 = 2,
    Code39 = 3,
    Code49 = 4,
    Ean8 = 5,
    UPC = 6,
    Code93 = 7,
    Code128 = 8,
    GS1_128 = 9,
    QR = 10,
    Custom = 11,
    QR_Image = 12,
    DataMatrix = 13,
}

export interface DatenbereinigungOptionen {
    optionen?: string[] | undefined;
}

export interface ExportConfig {
    optionen?: string[] | undefined;
}

export interface Benutzerrolle extends DefaultEntity {
    RoleName?: string | undefined;
    GeraeteGruppenEinschraenken?: boolean;
    Geraetegruppen?: string[] | undefined;
    FahrerNamenNichtAnzeigen?: boolean;
    permissions?: Permission[] | undefined;
}

export interface UvvKatalog extends DefaultEntity {
    name?: string | undefined;
    text?: string | undefined;
    intervall?: number;
    intervallTyp?: string | undefined;
    UnterMandant?: string | undefined;
    eintraege?: UvvEintrag[] | undefined;
}

export interface UvvEintrag {
    key?: string | undefined;
    bezeichnung?: string | undefined;
    beschreibungPflicht?: boolean;
    fotoPflicht?: boolean;
    pflicht?: boolean;
}

export interface UvvPruefGegenstand extends DefaultEntity {
    key?: string | undefined;
    bezeichnung?: string | undefined;
    identNummer?: string | undefined;
    manuelleNummer?: string | undefined;
    typ?: string | undefined;
    zustand?: string | undefined;
    standortAdressKey?: string | undefined;
    katalogName?: string | undefined;
    naechstePruefung?: string | undefined;
    letztePruefung?: string | undefined;
    UnterMandant?: string | undefined;
    Kennzeichen?: string | undefined;
    Herstellernummer?: string | undefined;
    Latitude?: number | undefined;
    Longitude?: number | undefined;
    Guid?: string | undefined;
}

export interface UvvPruefung extends DefaultEntity {
    ClientId?: string | undefined;
    GegenstandKey?: string | undefined;
    Status?: number;
    Datum?: string;
    KatalogName?: string | undefined;
    Pruefer?: string | undefined;
    PrueferPersonalnummer?: string | undefined;
    Pruefergebnis?: string | undefined;
    Anmerkungen?: string | undefined;
    StandortAdressKey?: string | undefined;
    Zustand?: string | undefined;
    Aktion?: string | undefined;
    UnterMandant?: string | undefined;
    Position?: GpsPosition | undefined;
    Eintraege?: UvvPruefungEintrag[] | undefined;
    Unterschrift?: Unterschrift | undefined;
}

export interface UvvPruefungEintrag {
    Key?: string | undefined;
    Name?: string | undefined;
    Status?: string | undefined;
    Anmerkungen?: string | undefined;
    Bilder?: ReCoMobilBild[] | undefined;
}

export interface AdresseEntity extends DefaultEntity {
    Key?: string | undefined;
    Name1?: string | undefined;
    Name2?: string | undefined;
    Name3?: string | undefined;
    Strasse?: string | undefined;
    PLZ?: string | undefined;
    Ort?: string | undefined;
    LKZ?: string | undefined;
    Telefon?: string | undefined;
    Ansprechpartner?: string | undefined;
    Sonstiges?: string | undefined;
    GeoX?: number | undefined;
    GeoY?: number | undefined;
    IsContainerAbstellort?: boolean;
    IsStandardContainerAbstellort?: boolean;
    IsVerwerter?: boolean;
    IsAdresseFuerNeueAuftraege?: boolean;
    IsNavigationsZiel?: boolean;
    NichtLoeschen?: boolean;
    GlasAnalyse?: boolean;
}

export interface ArtikelEntity extends DefaultEntity {
    geraeteNummer?: string | undefined;
    artikel?: Artikel | undefined;
    otherData?: { [key: string]: any; } | undefined;
}

export interface Artikel {
    Key?: string | undefined;
    artikelKey?: number;
    bezeichnung?: string | undefined;
    Bezeichnung2?: string | undefined;
    einheit?: string | undefined;
    artikelGruppe?: string | undefined;
    GewichtInKgAktiv?: boolean;
    GewichtInKgPflicht?: boolean;
    LaderaumAuswahlAktiv?: boolean | undefined;
    einzelVK?: number | undefined;
    mwstSatz?: number | undefined;
    StandardMenge?: number | undefined;
    MengeOption?: MengeOptionTyp | undefined;
    MinAnzahlBilder?: number | undefined;
    /** "Druck aktiv" des Artikels in ReCoLog. Gilt für Positionen, die der Fahrer selbst hinzufügt. */
    DruckErforderlich?: boolean | undefined;
    ArtikelAuswahl?: boolean | undefined;
    AuftragWiegungAktiv?: boolean | undefined;
    LaderaumArtikel?: boolean | undefined;
    UnterMandant?: string | undefined;
    BhAktion?: string | undefined;
    HofAktiv?: boolean | undefined;
    LPN?: string | undefined;
    GTIN?: string | undefined;
    Matchcode?: string | undefined;
    SeriennummerErforderlich?: boolean | undefined;
    Chargenpflicht?: boolean;
    NichtLoeschen?: boolean;
    eigenschaften?: ArtikelEigenschaft[] | undefined;
    otherData?: { [key: string]: any; } | undefined;
}

export interface ArtikelEigenschaft {
    sortierung?: number;
    key?: string | undefined;
    bezeichnung?: string | undefined;
    wert?: string | undefined;
    typ?: string | undefined;
    Regex?: string | undefined;
    Uppercase?: boolean | undefined;
    Sonderpruefung?: string | undefined;
    otherData?: { [key: string]: any; } | undefined;
}

export interface Artikelgruppe extends DefaultEntity {
    Name?: string | undefined;
    Beschreibung?: string | undefined;
    Icon?: string | undefined;
    Icon64?: string | undefined;
    IconSizeWidth?: number;
    IconSizeHeight?: number;
    Farbe?: string | undefined;
    Sortierung?: number;
    Deaktiviert?: boolean;
}

export interface AuftragEntity extends DefaultEntity {
    geraeteNummer?: string | undefined;
    geraeteBezeichnung?: string | undefined;
    key?: string | undefined;
    version?: number;
    status?: number;
    bilderGeloescht?: boolean;
    istBearbeitet?: boolean | undefined;
    istUnterauftrag?: boolean | undefined;
    pushStatus?: PushStatusType;
    auftrag?: Auftrag | undefined;
    Abholdatum?: string | undefined;
    AuftragStatusmeldungen?: AuftragStatusmeldung[] | undefined;
    PositionenInfoText?: string | undefined;
    Symbol?: string | undefined;
    AdresseInfoText?: string | undefined;
    TourReihenfolgeInfo?: string | undefined;
    otherData?: { [key: string]: any; } | undefined;
    Unterauftraege?: AuftragEntity[] | undefined;
}

export enum PushStatusType {
    Initial = 0,
    Pushed = 10,
    Received = 20,
}

export interface AuftragStatusmeldung {
    GeraeteNummer?: string | undefined;
    Datum?: string | undefined;
    Fahrzeug?: string | undefined;
    FahrzeugKey?: string | undefined;
    PersonalKey?: string | undefined;
    Statusmeldung?: string | undefined;
    StatusmeldungKey?: string | undefined;
    StatusmeldungZusatzinfo?: StatusmeldungZusatzinfo | undefined;
}

export interface AbfahrtskontrolleStatusEntity extends DefaultEntity {
    MandantName?: string | undefined;
    AngelegtAm?: string;
    Datum?: string;
    Typ?: string | undefined;
    FahrzeugKennzeichen?: string | undefined;
    FahrzeugKey?: string | undefined;
    PersonalKey?: string | undefined;
    PersonalName?: string | undefined;
    Personalnummer?: string | undefined;
    Key?: string | undefined;
    Name?: string | undefined;
    Beschreibung?: string | undefined;
    Status?: string | undefined;
    Anmerkungen?: string | undefined;
    GeraeteNummer?: string | undefined;
    GeraeteBezeichnung?: string | undefined;
    Bilder?: ReCoMobilBild[] | undefined;
    otherData?: { [key: string]: any; } | undefined;
}

export interface AuswertungResult {
    Items?: AuswertungItem[] | undefined;
    ErrorMessage?: string | undefined;
}

export interface AuswertungItem {
    Name?: string | undefined;
    GefahreneKilometer?: number;
    GefahreneKilometerAvg?: number;
    GefahreneKilometerGeschaetzt?: number;
    GefahreneKilometerGeschaetztAvg?: number;
    Fahrzeit?: number;
    FahrzeitAvg?: number;
    Hofzeit?: number;
    HofzeitAvg?: number;
    AktiverZeitraum?: number;
    AktiverZeitraumAvg?: number;
    Datenverbrauch?: number;
    DatenverbrauchAvg?: number;
    Statusmeldungen?: { [key: string]: number; } | undefined;
    StatusmeldungenAvg?: { [key: string]: number; } | undefined;
    AbgeschlosseneAuftraege?: GeraeteAuftragsStatistik | undefined;
}

export interface AuswertungRequest {
    DatumVon?: string;
    DatumBis?: string;
    GroupBy?: string | undefined;
}

export interface ZeiterfassungAuswertungResult {
    Items?: ZeiterfassungAuswertungItem[] | undefined;
    ErrorMessage?: string | undefined;
}

export interface ZeiterfassungAuswertungItem {
    Personal?: Personal | undefined;
    Datum?: string | undefined;
    Beginn?: string | undefined;
    Ende?: string | undefined;
    Arbeitszeit?: number;
    Pausenzeit?: number;
    PausenzeitinMin?: number;
    Zeiten?: { [key: string]: number; } | undefined;
}

export interface Personal extends DefaultEntity {
    Key?: string | undefined;
    vorname?: string | undefined;
    nachname?: string | undefined;
    personalnummer?: string | undefined;
    rfid?: string | undefined;
    standardFahrzeug?: string | undefined;
    passwortHash?: string | undefined;
    neuesPasswort?: string | undefined;
    uvvBerechtigt?: boolean | undefined;
    adrBerechtigt?: boolean | undefined;
    IstBeifahrer?: boolean | undefined;
    UnterMandant?: string | undefined;
    Icon128?: string | undefined;
    Icon64?: string | undefined;
    Eigenschaften?: PersonalEigenschaft[] | undefined;
    FuehrerscheinAblaufdatumInfo?: string | undefined;
    FuehrerscheiLetztePruefungInfo?: string | undefined;
    LetzteFuehrerscheinkontrolle?: PersonalKontrolleDaten | undefined;
    LetzteAnmeldung?: string | undefined;
    LetzteAbmeldung?: string | undefined;
    IstAngemeldet?: boolean | undefined;
    GeraeteNummer?: string | undefined;
    EMailAdresse?: string | undefined;
    DisplayName?: string | undefined;
}

export interface PersonalEigenschaft {
    Key?: string | undefined;
    Bezeichnung?: string | undefined;
    Bemerkung?: string | undefined;
    Ablaufdatum?: string | undefined;
    HinweisAbDatum?: string | undefined;
    PflichtBild?: boolean | undefined;
}

export interface PersonalKontrolleDaten {
    Typ?: string | undefined;
    PersonalKey?: string | undefined;
    Personalnummer?: string | undefined;
    Vorname?: string | undefined;
    Nachname?: string | undefined;
    UnterMandant?: string | undefined;
    Ablaufdatum?: string | undefined;
    Bilder?: ReCoMobilBild[] | undefined;
    Unterschrift?: Unterschrift | undefined;
    Status?: string | undefined;
    Rfid?: string | undefined;
}

export interface ZeiterfassungAuswertungRequest {
    DatumVon?: string;
    DatumBis?: string;
    PersonalKey?: string | undefined;
    Gruppierung?: string | undefined;
}

export interface Checkliste extends DefaultEntity {
    name?: string | undefined;
    titel?: string | undefined;
    typ?: ChecklisteTyp;
    eintraege?: ChecklisteEintrag[] | undefined;
}

export enum ChecklisteTyp {
    Unbekannt = 0,
    Annahmekontrolle = 1,
    Abfahrtskontrolle = 2,
}

export interface ChecklisteEintrag {
    Id?: string | undefined;
    sort?: number;
    key?: string | undefined;
    text?: string | undefined;
    beschreibungPflicht?: boolean | undefined;
    fotoPflicht?: boolean | undefined;
    antworten?: string | undefined;
    config?: string | undefined;
    Aktiv?: boolean | undefined;
}

export interface GlasAnalyseAuswertungResult {
    Items?: GlasAnalyse[] | undefined;
    ErrorMessage?: string | undefined;
}

export interface GlasAnalyse extends DefaultEntity {
    Guid?: string | undefined;
    Geraet?: string | undefined;
    DatumIso?: string;
    Anlage?: string | undefined;
    Datum?: string | undefined;
    Uhrzeit?: string | undefined;
    DatumMitUhrzeit?: string | undefined;
    LetzteErinnerung?: string | undefined;
    PersonalKey?: string | undefined;
    Personalnummer?: string | undefined;
    Material?: string | undefined;
    BoxNummer?: string | undefined;
    Pruefergebnis?: string | undefined;
    Anmerkungen?: string | undefined;
    Status?: string | undefined;
    AblehnungsGrund?: string | undefined;
    Bilder?: ReCoMobilBild[] | undefined;
    Werte?: { [key: string]: any; } | undefined;
    Analyseergebnis?: GlasAnalyseErgebnis[] | undefined;
    AnalyseergebnisMap?: { [key: string]: GlasAnalyseErgebnis; } | undefined;
}

export interface GlasAnalyseErgebnis {
    Name?: string | undefined;
    Wert?: number;
    Einheit?: string | undefined;
    Mittelwert?: number | undefined;
    Ablehnung?: number | undefined;
    GrenzeUeberschritten?: boolean;
    Massnahme?: string | undefined;
}

export interface GlasAnalyseAuswertungRequest {
    DatumVon?: string;
    DatumBis?: string;
    Anlage?: string | undefined;
    Material?: string | undefined;
}

export interface Bericht extends DefaultEntity {
    Datum?: string;
    Guid?: string | undefined;
    GeraeteNummer?: string | undefined;
    GeraeteGruppe?: string | undefined;
    UnterMandant?: string | undefined;
    Name?: string | undefined;
    Typ?: string | undefined;
    Status?: string | undefined;
    Personal?: PersonalRef | undefined;
    Fahrzeug?: FahrzeugRef | undefined;
    Daten?: { [key: string]: any; } | undefined;
    ListDaten?: { [key: string]: any; }[] | undefined;
    Bilder?: ReCoMobilBild[] | undefined;
    Unterschrift?: Unterschrift | undefined;
    otherData?: { [key: string]: any; } | undefined;
}

export interface PersonalRef {
    Key?: string | undefined;
    Vorname?: string | undefined;
    Nachname?: string | undefined;
    Personalnummer?: string | undefined;
}

export interface FahrzeugRef {
    Key?: string | undefined;
    Kennzeichen?: string | undefined;
}

export interface ExternesSystem extends DefaultEntity {
    Name?: string | undefined;
    Token?: string | undefined;
    Aktiv?: boolean;
    Einstellungen?: { [key: string]: string; } | undefined;
    LetzterKontakt?: string | undefined;
    Typ?: ExternsSystemTyp;
}

export enum ExternsSystemTyp {
    Standard = 0,
}

export interface Fahrzeug extends DefaultEntity {
    key?: string | undefined;
    kennzeichen?: string | undefined;
    standardFahrer?: string | undefined;
    fahrzeugGruppe?: string | undefined;
    rfid?: string | undefined;
    Leergewicht?: number | undefined;
    UnterMandant?: string | undefined;
    Typ?: FahrzeugTyp;
    Laderaeume?: Laderaum[] | undefined;
    Abfahrtskontrolle?: AbfahrtskontrolleErgebnis | undefined;
    Dispokategorien?: string[] | undefined;
    Icon128?: string | undefined;
    Icon64?: string | undefined;
    Kilometerstand?: number;
    KilometerstandDatum?: string | undefined;
    LetzterPersonalKey?: string | undefined;
    LetztesGeraet?: string | undefined;
    GeraeteNummer?: string | undefined;
    EMailAdresse?: string | undefined;
    LetzteWiegung?: WiegungInfoRef | undefined;
}

export enum FahrzeugTyp {
    LKW = 0,
    Anhaenger = 1,
}

export interface Laderaum {
    Nummer?: number;
    Bezeichnung?: string | undefined;
}

export interface AbfahrtskontrolleErgebnis {
    Eintraege?: AbfahrtskontrolleErgebnisEintrag[] | undefined;
}

export interface AbfahrtskontrolleErgebnisEintrag {
    Key?: string | undefined;
    NaechstePruefung?: string | undefined;
    LetzePruefung?: string | undefined;
    Status?: string | undefined;
    Anmerkungen?: string | undefined;
}

export interface Fahrzeuggruppe extends DefaultEntity {
    Name?: string | undefined;
    Bezeichnung?: string | undefined;
    Abfahrtskontrolle?: AbfahrtskontrolleFormular | undefined;
    Ankunftskontrolle?: AbfahrtskontrolleFormular | undefined;
}

export interface Gastzugang extends DefaultEntity {
    Token?: string | undefined;
    Bezeichnung?: string | undefined;
    Link?: string | undefined;
    AngelegtAm?: string | undefined;
    AngelegtVon?: string | undefined;
    Passwort?: string | undefined;
    SichtbareGeraeteNummern?: string[] | undefined;
    SichtbareGeraeteGruppen?: string[] | undefined;
    VerlaufAnzeigen?: boolean;
    AuftraegeAnzeigen?: boolean;
    StatusmeldungenAnzeigen?: boolean;
    AnzahlTageHistorie?: number;
}

export interface DeleteStapelRequest {
    Ids?: string[] | undefined;
}

export interface GlasAnalyseBatchRequest {
    Ids?: string[] | undefined;
    AblehnungsGrund?: string | undefined;
    Anmerkungen?: string | undefined;
}

export interface Appointment {
    StartDate?: string;
    EndDate?: string;
    AllDay?: boolean;
    Auftrag?: Auftrag | undefined;
    Typ?: AppointmentType;
    Text?: string | undefined;
    Status?: number;
    Id?: string | undefined;
    Key?: string | undefined;
    Farbe?: string | undefined;
    ResourceId?: string | undefined;
}

export enum AppointmentType {
    Auftrag = 0,
}

export interface KalenderRequest {
    StartDate?: string | undefined;
    EndDate?: string | undefined;
}

export interface KarteDaten {
    errorMessage?: string | undefined;
    geraete?: GeraetDaten[] | undefined;
    Auftraege?: AuftragEntity[] | undefined;
}

export interface GeraetDaten {
    GeraeteNummer?: string | undefined;
    LetztePosition?: GeoPosition | undefined;
    Positionen?: GeoPosition[] | undefined;
    Fahrtrichtung?: number;
    AktuellerAuftragDatum?: string | undefined;
    AktuellerAuftrag?: Auftrag | undefined;
    ZuletztOnline?: string | undefined;
    IstWebSocketVerbunden?: boolean | undefined;
    FahrzeugKey?: string | undefined;
    FahrzeugKennzeichen?: string | undefined;
    AnhaengerKey?: string | undefined;
    AnhaengerKennzeichen?: string | undefined;
    Personalnummer?: string | undefined;
    PersonalName?: string | undefined;
    PersonalKey?: string | undefined;
    TelematikStatus?: TelematikStatusTyp | undefined;
    AktuellAnzahlAuftraegeOffen?: number | undefined;
    AktuellAnzahlAuftraegeErledigt?: number | undefined;
    AktuellAnzahlAuftraegeAbgelehnt?: number | undefined;
    IstOnline?: boolean | undefined;
}

export interface KarteFilter2 {
    IsFilterAktiv?: boolean;
    Datum?: string | undefined;
    GeraeteNummern?: string[] | undefined;
    DetailsGeraeteNummern?: string[] | undefined;
    PositionenGlaetten?: boolean | undefined;
    PfeileFahrtrichtungAnzeigen?: boolean | undefined;
    MaxAccuracy?: number | undefined;
    AllePositionenAnzeigen?: boolean | undefined;
    UhrzeitFilterAktiv?: boolean | undefined;
    UhrzeitVon?: string | undefined;
    UhrzeitBis?: string | undefined;
    UhrzeitRange?: number[] | undefined;
}

export interface KarteSucheAdresseResult {
    Longitude?: number | undefined;
    Latitude?: number | undefined;
    ErrorMessage?: string | undefined;
    Auftraege?: AuftragEntity[] | undefined;
}

export interface KarteSucheAdresseRequest {
    Suchtext?: string | undefined;
    Datum?: string | undefined;
}

export interface GeocodeResult {
    Longitude?: number | undefined;
    Latitude?: number | undefined;
    ErrorMessage?: string | undefined;
    Auftraege?: Auftrag[] | undefined;
}

export interface GpxExportRequest {
    GeraeteNummer?: string | undefined;
    DatumVon?: string | undefined;
    DatumBis?: string | undefined;
    UhrzeitVon?: string | undefined;
    UhrzeitBis?: string | undefined;
}

export interface Masterdata extends DefaultEntity {
    MandantName?: string | undefined;
    Typ?: MasterdataTyp;
    Name?: string | undefined;
    Key?: string | undefined;
    Anmerkungen?: string | undefined;
    CustomValues?: { [key: string]: any; } | undefined;
    otherData?: { [key: string]: any; } | undefined;
}

export enum MasterdataTyp {
    Unbekannt = 0,
    Kostenstelle = 1,
}

export interface NachrichtenStatusResult {
    AnzahlNichtGelesen?: number;
}

export interface NachrichtEntity extends DefaultEntity {
    geraeteId?: string | undefined;
    GeraeteNummer?: string | undefined;
    GeraeteBezeichnung?: string | undefined;
    PersonalName?: string | undefined;
    FahrzeugKey?: string | undefined;
    FahrzeugKennzeichen?: string | undefined;
    nachricht?: Nachricht | undefined;
}

export interface Nachricht {
    Timestamp?: number;
    Guid?: string | undefined;
    Absender?: string | undefined;
    AbsenderTyp?: NachrichtAbsenderTyp;
    Empfaenger?: string | undefined;
    Text?: string | undefined;
    Datum?: string | undefined;
    Dringend?: boolean;
    Gelesen?: boolean;
    GelesenDatum?: string | undefined;
    GelesenVon?: string | undefined;
    UnterMandant?: string | undefined;
    Dateien?: ReCoMobilDokument[] | undefined;
    Position?: GpsPosition | undefined;
    PrevGuids?: string[] | undefined;
    otherData?: { [key: string]: any; } | undefined;
}

export enum NachrichtAbsenderTyp {
    Geraet = 0,
    Web = 1,
    Extern = 2,
}

export interface SendNachrichtResult extends SaveResult {
    nachricht?: NachrichtEntity | undefined;
}

export interface SendNachrichtRequest {
    geraeteIds?: string[] | undefined;
    text?: string | undefined;
    dringend?: boolean;
    PrevGuids?: string[] | undefined;
}

export interface NVE extends DefaultEntity {
    Key?: string | undefined;
    Lieferant?: string | undefined;
    MHD?: string | undefined;
    Charge?: string | undefined;
    GTIN?: string | undefined;
    MengeInitial?: number | undefined;
    MengeAktuell?: number | undefined;
    Bezeichnung?: string | undefined;
}

export interface AuftragProtokoll extends DefaultEntity {
    GeraeteNummer?: string | undefined;
    GeraeteBezeichnung?: string | undefined;
    AuftragKey?: string | undefined;
    Auftragsnummer?: number | undefined;
    Name1?: string | undefined;
    Name2?: string | undefined;
    Strasse?: string | undefined;
    PLZ?: string | undefined;
    Ort?: string | undefined;
    Datum?: string;
    Typ?: string | undefined;
    Text?: string | undefined;
    Info1?: string | undefined;
    Info2?: string | undefined;
    Info3?: string | undefined;
    Info4?: string | undefined;
    Info5?: string | undefined;
    Info6?: string | undefined;
    BelegNummern?: string | undefined;
    Hash?: string | undefined;
    PersonalKey?: string | undefined;
    PersonalName?: string | undefined;
    Personalnummer?: string | undefined;
    otherData?: { [key: string]: any; } | undefined;
}

export interface Regel extends DefaultEntity {
    Name?: string | undefined;
    Sortierung?: number;
    Anmerkungen?: string | undefined;
    Guid?: string | undefined;
    Aktiv?: boolean;
    Typ?: RegelTyp;
    Bedingung?: RegelBedingung | undefined;
    Aktion?: RegelAktion | undefined;
    otherData?: { [key: string]: any; } | undefined;
}

export enum RegelTyp {
    Unbekannt = 0,
    Auftrag = 1,
    NichtNebeneinander = 2,
}

export interface RegelBedingung {
    Artikelnummern?: string | undefined;
    Artikelbezeichnungen?: string | undefined;
    MengeVorhanden?: boolean;
    Geraetegruppe?: string | undefined;
    otherData?: { [key: string]: any; } | undefined;
}

export interface RegelAktion {
    MinAnzahlBilderAktiv?: boolean;
    MinAnzahlBilder?: number | undefined;
    MinAnzahlBilderMeldung?: string | undefined;
    Meldung1?: string | undefined;
    MeldungTextFarbe?: string | undefined;
    MeldungHintergrundFarbe?: string | undefined;
    BilderFuerVeterinear?: boolean;
    KeineWeitereRegel?: boolean;
    otherData?: { [key: string]: any; } | undefined;
}

export interface Stammtour extends DefaultEntity {
    Key?: string | undefined;
    Name?: string | undefined;
    Intervall?: string | undefined;
    UnterMandant?: string | undefined;
    Montag?: boolean;
    Dienstag?: boolean;
    Mittwoch?: boolean;
    Donnerstag?: boolean;
    Freitag?: boolean;
    Samstag?: boolean;
    Sonntag?: boolean;
    otherData?: { [key: string]: any; } | undefined;
    WochentagInfo?: string | undefined;
}

export interface StatusmeldungEntity extends DefaultEntity {
    Datum?: string;
    Typ?: StatusmeldungTyp;
    GeraeteId?: string | undefined;
    GeraeteNummer?: string | undefined;
    GeraeteBezeichnung?: string | undefined;
    PersonalKey?: string | undefined;
    PersonalName?: string | undefined;
    AuftragKey?: string | undefined;
    Text?: string | undefined;
    Timestamp?: number;
}

export enum StatusmeldungTyp {
    Unbekannt = 0,
    Tour = 1,
    Auftrag = 2,
    Nachricht = 3,
    Uvv = 3,
    Stammdaten = 4,
    Diagnosedaten = 5,
    Personal = 6,
}

export interface Statuszusatzinfo extends DefaultEntity {
    Key?: string | undefined;
    Name?: string | undefined;
    Felder?: StatuszusatzinfoFeld[] | undefined;
}

export interface StatuszusatzinfoFeld {
    Sortierung?: number;
    Key?: string | undefined;
    Bezeichnung?: string | undefined;
    Typ?: string | undefined;
    StandardWert?: string | undefined;
    Erforderlich?: boolean | undefined;
}

export interface TextEntity extends DefaultEntity {
    Key?: string | undefined;
    DE?: string | undefined;
    IsHtml?: boolean;
    otherData?: { [key: string]: any; } | undefined;
}

export interface TourGeraeteDaten {
    Geraete?: GeraetDto[] | undefined;
    Success?: boolean;
    ErrorMessage?: string | undefined;
}

export interface TourGeraeteFilter {
    Datum?: string | undefined;
    Draw?: number;
}

export interface Tourenplan extends DefaultEntity {
    Datum?: string;
    Name?: string | undefined;
    Status?: string | undefined;
    Stammtouren?: boolean;
    UnterMandanten?: string[] | undefined;
    AngelegtVon?: string | undefined;
    AnzahlTouren?: number;
    AnzahlAuftraege?: number;
    SummeMenge?: number | undefined;
    SummeDauer?: number | undefined;
    SummeDistanz?: number | undefined;
    AuftragFilter?: TourenplanungAuftragFilter | undefined;
    Touren?: DispoTour[] | undefined;
    DispoAuftraege?: DispoAuftrag[] | undefined;
    otherData?: { [key: string]: any; } | undefined;
}

export interface TourenplanungAuftragFilter {
    DatumVon?: string | undefined;
    DatumBis?: string | undefined;
    DatumZeitraumVerwenden?: boolean;
    Dispokategorien?: string[] | undefined;
    Suchtext?: string | undefined;
}

export interface DispoTour {
    Key?: string | undefined;
    TourKey?: string | undefined;
    StammTourKey?: string | undefined;
    Name?: string | undefined;
    FahrzeugKey?: string | undefined;
    PersonalKey?: string | undefined;
    GeraeteNummer?: string | undefined;
    UnterMandant?: string | undefined;
}

export interface DispoAuftrag {
    AuftragKey?: string | undefined;
    Abholdatum?: string;
    DispoTourKey?: string | undefined;
    Reihenfolge?: number;
    Abholadresse?: Adresse | undefined;
    Dispokategorie?: string | undefined;
    ATOGesamtgewichtKG?: number | undefined;
    ATOGesamtvolumenLtr?: number | undefined;
    ATOGesamtstellplatz?: number | undefined;
    ATOStandZeitInMinuten?: number | undefined;
    ATOLieferzeitfensterBeginn?: string | undefined;
    ATOLieferzeitfensterEnde?: string | undefined;
    ATOFahrzeugFix?: boolean | undefined;
    Stammtour?: string | undefined;
    Status?: number;
}

export interface Vertrag extends DefaultEntity {
    Key?: string | undefined;
    Vertragsnummer?: string | undefined;
    Bezeichnung?: string | undefined;
    Text?: string | undefined;
    UnterMandant?: string | undefined;
    Abholadresse?: Adresse | undefined;
    Erzeugeradresse?: Adresse | undefined;
    Verwerteradresse?: Adresse | undefined;
    Befoerdereradresse?: Adresse | undefined;
    Positionen?: Auftragsposition[] | undefined;
    Hinweistexte?: Hinweistext[] | undefined;
    Anlagen?: ReCoMobilDokument[] | undefined;
    WorkflowName?: string | undefined;
    Info1?: string | undefined;
    Info2?: string | undefined;
    Info3?: string | undefined;
    Info4?: string | undefined;
    Info5?: string | undefined;
    DetailInfo1?: string | undefined;
    DetailInfo2?: string | undefined;
    DetailInfo3?: string | undefined;
    Kontakte?: Kontakt[] | undefined;
    Zusatzdaten?: { [key: string]: string; } | undefined;
    pushStatus?: PushStatusType;
    PositionenInfoText?: string | undefined;
    Hash?: string | undefined;
    otherData?: { [key: string]: any; } | undefined;
}

export interface Waage extends DefaultEntity {
    Key?: string | undefined;
    Name?: string | undefined;
    UnterMandant?: string | undefined;
    Einheit?: EinheitTyp;
    Config?: string | undefined;
    ErpWaageName?: string | undefined;
    ApiToken?: string | undefined;
    Latitude?: number;
    Longitude?: number;
    MaxEntfernung?: number;
    IstVerbunden?: boolean;
    TimeoutSekunden?: number;
    IstEntfernung?: number | undefined;
}

export enum EinheitTyp {
    Unbekannt = 0,
    KG = 1,
    Tonne = 2,
}

export interface WiegenResult {
    WaageKey?: string | undefined;
    Success?: boolean;
    Message?: string | undefined;
    Datum?: string | undefined;
    Gewicht?: number;
    WiegeNr?: string | undefined;
    Position?: GpsPosition | undefined;
}

export interface WerkstattFahrzeugMangel extends DefaultEntity {
    MandantName?: string | undefined;
    AngelegtAm?: string;
    Datum?: string;
    ErledigtAm?: string | undefined;
    UnterMandant?: string | undefined;
    ErledigtVon?: string | undefined;
    Nummer?: number;
    ErledigtVonList?: string[] | undefined;
    Kostenstellen?: string[] | undefined;
    FahrzeugKennzeichen?: string | undefined;
    FahrzeugKey?: string | undefined;
    PersonalKey?: string | undefined;
    PersonalName?: string | undefined;
    Personalnummer?: string | undefined;
    Key?: string | undefined;
    Name?: string | undefined;
    Status?: string | undefined;
    Anmerkungen?: string | undefined;
    Bemerkungen?: string | undefined;
    Arbeitszeit?: number | undefined;
    Diagnosezeit?: number | undefined;
    Kosten?: number | undefined;
    ManuellAngelegt?: boolean;
    AngelegVon?: string | undefined;
    KmmitErstatzfahrzeug?: number | undefined;
    KostenstelleInfo?: string | undefined;
    otherData?: { [key: string]: any; } | undefined;
}

export interface Zeiterfassung extends DefaultEntity {
    Erfasser?: PersonalRef | undefined;
    Geraet?: GeraetRef | undefined;
    Personal?: PersonalRef | undefined;
    Typ?: ZeiterfassungTyp;
    Datum?: string | undefined;
    UhrzeitVon?: string | undefined;
    UhrzeitBis?: string | undefined;
    StartDatum?: string | undefined;
    EndeDatum?: string | undefined;
    Guid?: string | undefined;
    GruppeKey?: string | undefined;
    Text?: string | undefined;
    PausenListe?: ZeiterfassungPause[] | undefined;
}

export interface GeraetRef {
    GeraeteNummer?: string | undefined;
    Bezeichnung?: string | undefined;
}

export enum ZeiterfassungTyp {
    Unbekannt = 0,
}

export interface ZeiterfassungPause {
    PauseTyp?: ZeiterfassungPauseTyp;
    StartDatum?: string | undefined;
    EndeDatum?: string | undefined;
    Text?: string | undefined;
}

export enum ZeiterfassungPauseTyp {
    Unbekannt = 0,
}

export interface WorkflowEntity extends DefaultEntity {
    workflow?: Workflow | undefined;
}

export interface Workflow {
    name?: string | undefined;
    beschreibung?: string | undefined;
    checkliste?: string | undefined;
    fallback?: boolean | undefined;
    status?: WorkflowStatus[] | undefined;
    Formular?: AuftragsFormular | undefined;
    WizardKonfiguration?: WizardKonfiguration | undefined;
    einstellungen?: { [key: string]: string; } | undefined;
}

export interface WorkflowStatus {
    id?: number;
    name?: string | undefined;
    key?: string | undefined;
    sortierung?: number;
    icon?: string | undefined;
    minAnzahlBilder?: number;
    bildErforderlich?: boolean;
    unterschriftErforderlich?: boolean;
    anmerkungErforderlich?: boolean;
    GeopositionExaktErfassen?: boolean;
    geopositionSenden?: boolean;
    auftragsdatenSenden?: boolean;
    bilderSenden?: boolean;
    unterschriftSenden?: boolean;
    AlleMengenAufNull?: boolean;
    auftragAbschliessen?: boolean;
    auftragsstatus?: number | undefined;
    buttonAnzeigen?: boolean;
    ButtonAnzeigen2?: boolean;
    ButtonAnzeigen3?: boolean;
    InAuftragsPopupAnzeigen?: boolean;
    NachAbschlussErlaubt?: boolean;
    BehaelterNummerHandeingabeFotoErforderlich?: boolean;
    StandardStartAktion?: boolean;
    StandardFertigAktion?: boolean;
    AutoDruckDruckformular?: string | undefined;
    EmailBenachrichtigung?: string | undefined;
    buttonFarbe?: string | undefined;
    AuftragsFarbe?: string | undefined;
    statuszusatzinfoKey?: string | undefined;
    FuerAlleAuftraegeAnEinsatzort?: boolean;
    statuszusatzinfo?: Statuszusatzinfo | undefined;
    vorgaenger?: string[] | undefined;
    AbholstelleFertig?: boolean;
    erlaubteVorgaengerStatus?: { [key: string]: boolean; } | undefined;
    otherData?: { [key: string]: any; } | undefined;
}

export interface WizardKonfiguration {
    WizardPages?: WizardPage[] | undefined;
}

export interface WizardPage {
    Id?: number;
    Titel?: string | undefined;
    Aktiv?: boolean | undefined;
    Sortierung?: number;
    Notizen?: string | undefined;
    Formular?: AuftragsFormular | undefined;
    AnzeigeBedingung?: WizardPageAnzeigeBedingung | undefined;
    AbschlussBedingung?: WizardPageAbschlussBedingung | undefined;
    Statusmeldungen?: { [key: string]: boolean; } | undefined;
}

export interface WizardPageAnzeigeBedingung {
    VerwerteradresseVorhanden?: boolean | undefined;
    HinweistexteVorhanden?: boolean | undefined;
    AnlagenVorhanden?: boolean | undefined;
    ChecklisteVorhanden?: boolean | undefined;
    PreiseVorhanden?: boolean | undefined;
}

export interface WizardPageAbschlussBedingung {
    LieferungVollstaendig?: boolean | undefined;
    UnterschriftenVollstaendig?: boolean | undefined;
    WiegungErfolgreich?: boolean | undefined;
    ChecklisteVollstaendig?: boolean | undefined;
    Statusmeldung?: boolean | undefined;
}

export interface AppLoginResult {
    success?: boolean;
    message?: string | undefined;
    errorCode?: string | undefined;
    token?: string | undefined;
    GeraeteBezeichnung?: string | undefined;
    GeraeteGruppe?: string | undefined;
    Geraetegruppen?: string[] | undefined;
    UnterMandant?: string | undefined;
    Anlagen?: string[] | undefined;
    einstellungen?: AppEinstellungen | undefined;
    ArbeitszeitKonfiguration?: ArbeitszeitKonfiguration | undefined;
    StoerzeitKonfiguration?: StoerzeitKonfiguration | undefined;
    GlasAnalyse?: GlasAnalyseEinstellungen | undefined;
}

export interface AppEinstellungen {

    [key: string]: string | any;
}

export interface AppLoginRequest {
    mandant?: string | undefined;
    geraeteNummer?: string | undefined;
    passwort?: string | undefined;
    qrToken?: string | undefined;
    loginToken?: string | undefined;
    deviceId?: string | undefined;
    appVersion?: number;
}

export interface AppTexteResult {
    Items?: AppText[] | undefined;
    ErrorMessage?: string | undefined;
}

export interface AppText {
    Key?: string | undefined;
    Text?: string | undefined;
    IsHtml?: boolean;
    Language?: string | undefined;
}

export interface AppUpdateInfo {
    Version?: number;
    Name?: string | undefined;
    Url?: string | undefined;
}

export interface AppStammdatenResult {
    artikelgruppen?: Artikelgruppe[] | undefined;
    artikel?: Artikel[] | undefined;
    workflows?: Workflow[] | undefined;
    formulare?: MandantFormulare | undefined;
    checklisten?: Checkliste[] | undefined;
    adressen?: AdresseEntity[] | undefined;
    druckformulare?: Druckformular[] | undefined;
    regeln?: Regel[] | undefined;
    timestamp?: number;
}

export interface AppTourStartResult extends SaveResult {
}

export interface AppTourStartRequest {
    TourKey?: string | undefined;
    TourKeys?: string[] | undefined;
}

export interface Tour {
    Key?: string | undefined;
    Datum?: string | undefined;
    Bezeichnung?: string | undefined;
    GeraeteNummer?: string | undefined;
    FahrzeugKey?: string | undefined;
    FahrzeugKennzeichen?: string | undefined;
    AnhaengerKey?: string | undefined;
    AnhaengerKennzeichen?: string | undefined;
    Status?: number;
    LoescheAlleAuftraege?: boolean;
    UnterMandant?: string | undefined;
    otherData?: { [key: string]: any; } | undefined;
}

export interface AppGeraetegruppeWechselnRequest {
    Geraetegruppe?: string | undefined;
}

export interface PushRegistrationRequest {
    uniqueDeviceId?: string | undefined;
    registrationId?: string | undefined;
    registrationType?: string | undefined;
    platform?: string | undefined;
}

export interface ChangeLogResult {
    changeLogs?: ChangeLogDto[] | undefined;
    fullSyncRequired?: boolean;
    timestamp?: number;
}

export interface ChangeLogDto {
    changeType?: ChangeType;
    elementTyp?: ElementTyp;
    key?: string | undefined;
    element?: any | undefined;
}

export enum ChangeType {
    Unbekannt = 0,
    Neu = 1,
    Geaendert = 2,
    Geloescht = 3,
}

export enum ElementTyp {
    Unbekannt = 0,
    Nachricht = 1,
    Auftrag = 2,
    Adresse = 3,
    Fahrzeug = 4,
    Personal = 5,
    Dokument = 6,
    Konfiguration = 7,
    UvvKatalog = 8,
    UvvGegenstand = 9,
}

export interface SendResult {
    success?: boolean;
    message?: string | undefined;
}

export interface Textdatei {
    typ?: TextdateiTyp;
    key?: string | undefined;
    geraeteNummer?: string | undefined;
    geraeteGruppe?: string | undefined;
    ExternesSystemId?: string | undefined;
    AppVersion?: string | undefined;
    OsVersion?: string | undefined;
    datum?: string | undefined;
    Fehlermeldung?: string | undefined;
    fehlerCode?: string | undefined;
    AbsenderBenutzerKey?: string | undefined;
    auftrag?: any | undefined;
    tour?: Tour | undefined;
    stammdaten?: Stammdaten | undefined;
    geraetekonfiguration?: Geraetekonfiguration | undefined;
    tourStatus?: TourStatus | undefined;
    diagnosedaten?: any | undefined;
    uvvPruefung?: UvvPruefung | undefined;
    dokumente?: ReCoMobilDokumente | undefined;
    anmeldung?: Anmeldung | undefined;
    nachricht?: Nachricht | undefined;
    positionen?: ReCoMobilGeoPosition[] | undefined;
    Position?: GpsPosition | undefined;
    DeviceInfo?: { [key: string]: string; } | undefined;
    DokumentLesebestaetigung?: DokumentLesebestaetigung | undefined;
    GeloeschteWiegungen?: GeloeschteWiegungen | undefined;
    HinweistextLesebestaetigung?: HinweistextLesebestaetigung | undefined;
    Nachrichten?: Nachricht[] | undefined;
    Empfangsbestaetigungen?: Empfangsbestaetigung[] | undefined;
    Navigation?: Navigationsdaten | undefined;
    AuftragWeiterleiten?: AuftragWeiterleitenDaten | undefined;
    TextInformation?: TextInformationDaten | undefined;
    PersonalKontrolle?: PersonalKontrolleDaten | undefined;
    Behaelter?: UvvPruefGegenstand | undefined;
    GlasAnalyse?: GlasAnalyse | undefined;
    Bericht?: Bericht | undefined;
    UvvHinweisMeldung?: UvvHinweisMeldung | undefined;
    Wiegung?: WiegungInfo | undefined;
    Bild?: ReCoMobilBild | undefined;
    GpsPositionen?: GpsPositionPush[] | undefined;
}

export enum TextdateiTyp {
    Unbekannt = 0,
    Auftrag = 1,
    Nachricht = 2,
    Stammdaten = 3,
    Position = 4,
    TourStatus = 5,
    Diagnosedaten = 6,
    UvvPruefung = 7,
    Dokumente = 8,
    Anmeldung = 9,
    Lesebestaetigung = 10,
    Tour = 11,
    GeloeschteWiegungen = 12,
    UvvGegenstandAktualisiert = 13,
    ImportFehler = 14,
    LogDatei = 15,
    AuftragBackup = 16,
    HinweistextLesebestaetigung = 17,
    NachrichtGelesen = 18,
    Empfangsbestaetigung = 19,
    StartNavigation = 20,
    AuftragWeiterleiten = 21,
    TextInformation = 22,
    PersonalKontrolle = 23,
    NeuerBehaelter = 24,
    GlasAnalyse = 25,
    PaletteAuftrag = 26,
    NVEs = 27,
    Bericht = 28,
    UvvHinweisMeldung = 29,
    Wiegung = 30,
    Bild = 31,
    Positionen = 32,
    Free33 = 33,
}

export interface Stammdaten {
    Artikel?: Artikel[] | undefined;
    Personal?: ReCoMobilPersonal[] | undefined;
    Fahrzeuge?: Fahrzeug[] | undefined;
    Uvv?: ReCoMobilUvv[] | undefined;
    Behaelter?: UvvPruefGegenstand[] | undefined;
    Workflows?: Workflow[] | undefined;
    MandantenAnlagen?: ReCoMobilAnlage[] | undefined;
    Vertraege?: Vertrag[] | undefined;
    NVEs?: NVE[] | undefined;
    IsVollstaendigeListe?: boolean | undefined;
}

export interface ReCoMobilPersonal {
    Key?: string | undefined;
    personalnummer?: string | undefined;
    vorname?: string | undefined;
    nachname?: string | undefined;
    rfid?: string | undefined;
    standardFahrzeug?: string | undefined;
    uvvBerechtigt?: boolean | undefined;
    IstBeifahrer?: boolean | undefined;
    UnterMandant?: string | undefined;
    passwort?: string | undefined;
    passwortUeberschreiben?: boolean;
    Eigenschaften?: PersonalEigenschaft[] | undefined;
    Icon?: string | undefined;
    IconSizeWidth?: number | undefined;
    IconSizeHeight?: number | undefined;
    GeraeteNummer?: string | undefined;
    EMailAdresse?: string | undefined;
}

export interface ReCoMobilUvv {
    Key?: string | undefined;
    IdentNummer?: string | undefined;
    Bezeichnung?: string | undefined;
    Typ?: string | undefined;
    UvvKatalog?: string | undefined;
    LetztePruefung?: string | undefined;
    NaechstePruefung?: string | undefined;
    ManuelleNummer?: string | undefined;
    UnterMandant?: string | undefined;
}

export interface ReCoMobilAnlage {
    art?: string | undefined;
    dateiTyp?: string | undefined;
    dateiname?: string | undefined;
    inhalt?: string | undefined;
}

export interface Geraetekonfiguration {
    geraeteNummer?: string | undefined;
    passwort?: string | undefined;
    geloescht?: boolean;
    einstellungen?: { [key: string]: any; } | undefined;
}

export interface TourStatus {
    Key?: string | undefined;
    Guid?: string | undefined;
    Statuszeit?: string | undefined;
    Status?: TourStatusTyp | undefined;
    TourKey?: string | undefined;
    TourKeys?: string[] | undefined;
    TourTyp?: TourTyp;
    TourDatum?: string | undefined;
    TourBezeichnung?: string | undefined;
    Geraet?: string | undefined;
    GeraeteGruppe?: string | undefined;
    Personalnummer?: string | undefined;
    PersonalKey?: string | undefined;
    BeifahrerKey?: string | undefined;
    BeifahrerKey2?: string | undefined;
    Fahrzeug?: string | undefined;
    FahrzeugKey?: string | undefined;
    AnhaengerKey?: string | undefined;
    Anhaenger?: string | undefined;
    Datum?: string | undefined;
    Uhrzeit?: string | undefined;
    StartDatum?: string | undefined;
    Kilometerstand?: number | undefined;
    Entladeort?: string | undefined;
    Kilometer?: number | undefined;
    DauerMinuten?: number | undefined;
    TankenLiter?: number | undefined;
    ErstwiegungErfolgt?: boolean | undefined;
    ZweitwiegungErfolgt?: boolean | undefined;
    UnterMandant?: string | undefined;
    Abfahrtskontrolle?: AbfahrtskontrolleStatus[] | undefined;
    AbfahrtskontrolleAnhaenger?: AbfahrtskontrolleStatus[] | undefined;
    AbfahrtskontrolleProtokollierung?: AbfahrtskontrolleProtokollierung | undefined;
    Ankunftskontrolle?: AbfahrtskontrolleStatus[] | undefined;
    AnkunftskontrolleAnhaenger?: AbfahrtskontrolleStatus[] | undefined;
    AnkunftskontrolleProtokollierung?: AbfahrtskontrolleProtokollierung | undefined;
    Laederaeume?: TourStatusLaderaum[] | undefined;
    AbgeschlosseneAuftraege?: TourStatusAuftragsdaten[] | undefined;
    SummeGewichtInKg?: number | undefined;
    SummeMenge?: { [key: string]: number; } | undefined;
    Auswahl?: string | undefined;
    Stoerzeiten?: Stoerzeit[] | undefined;
    Wiegung?: TourWiegung | undefined;
    TourStartWiegung?: LaderaumWiegung | undefined;
    Unterschrift?: Unterschrift | undefined;
    UnterschriftName?: string | undefined;
    WiegescheinNummer?: number | undefined;
    WiegenArtikelKey?: number | undefined;
    WiegescheinBilder?: ReCoMobilBild[] | undefined;
    Zeiterfassung?: TourZeiterfassung | undefined;
    BeifahrerListe?: BeifahrerDaten[] | undefined;
}

export enum TourStatusTyp {
    None = 0,
    Start = 1,
    Unterbrochen = 2,
    Ende = 3,
    Fahrzeugkontrolle = 4,
    Zeiterfassung = 5,
    Free6 = 6,
    Free7 = 7,
    Free8 = 8,
    Free9 = 9,
}

export enum TourTyp {
    Standard = 0,
    AdHoc = 1,
    Free2 = 2,
    Free3 = 3,
    Free4 = 4,
    Free5 = 5,
    Free6 = 6,
    Free7 = 7,
    Free8 = 8,
    Free9 = 9,
}

export interface AbfahrtskontrolleStatus {
    Key?: string | undefined;
    Name?: string | undefined;
    Status?: string | undefined;
    Anmerkungen?: string | undefined;
    Bilder?: ReCoMobilBild[] | undefined;
}

export interface AbfahrtskontrolleProtokollierung {
    Beginn?: string | undefined;
    Ende?: string | undefined;
    Dauer?: number;
    DauerSoll?: number;
    Positionen?: ReCoMobilGeoPosition[] | undefined;
}

export interface ReCoMobilGeoPosition {
    Timestamp?: number;
    Latitude?: number;
    Longitude?: number;
    Accuracy?: number | undefined;
    Speed?: number | undefined;
    Bearing?: number | undefined;
}

export interface TourStatusLaderaum {
    LaderaumNummer?: number;
    LaderaumBezeichnung?: string | undefined;
    InhaltArtikelKey?: number | undefined;
    InhaltArtikelBezeichnung?: string | undefined;
    Wiegungen?: LaderaumWiegung[] | undefined;
    NettoGewicht?: number | undefined;
    LaderaumErstwiegungErfolgt?: boolean | undefined;
    LaderaumZweitwiegungErfolgt?: boolean | undefined;
}

export interface LaderaumWiegung {
    Nummer?: number;
    Datum?: string | undefined;
    Gewicht?: number | undefined;
    WiegeNr?: string | undefined;
    WaageKey?: string | undefined;
    WaageUnterMandant?: string | undefined;
    Einheit?: string | undefined;
    Typ?: WiegungTyp;
}

export interface TourStatusAuftragsdaten {
    AuftragKey?: string | undefined;
    Auftragsnummer?: number | undefined;
    Auftragstyp?: Auftragstyp | undefined;
    GewichtInKg?: number | undefined;
    Mengen?: { [key: string]: number; } | undefined;
}

export interface TourWiegung {
    Wiegungen?: LaderaumWiegung[] | undefined;
    NettoGewicht?: number | undefined;
    ErstwiegungErfolgt?: boolean | undefined;
    ZweitwiegungErfolgt?: boolean | undefined;
    LeergewichtGeaendert?: boolean | undefined;
}

export interface TourZeiterfassung {
    Eintraege?: ZeitEintrag[] | undefined;
}

export interface BeifahrerDaten {
    Id?: string | undefined;
    PersonalKey?: string | undefined;
    Vorname?: string | undefined;
    Nachname?: string | undefined;
    Personalnummer?: string | undefined;
    AngemeldetVon?: string | undefined;
    AngemeldetBis?: string | undefined;
}

export interface ReCoMobilDokumente {
    typ?: string | undefined;
    typKey?: string | undefined;
    anhaengen?: boolean;
    dateien?: ReCoMobilDokument[] | undefined;
}

export interface Anmeldung {
    Datum?: string;
    PersonalKey?: string | undefined;
    Personalnummer?: string | undefined;
    Modus?: string | undefined;
    Typ?: string | undefined;
    UnterMandant?: string | undefined;
}

export interface DokumentLesebestaetigung {
    Dateiname?: string | undefined;
    Personalnummer?: string | undefined;
    GeoeffnetDatum?: string | undefined;
    BestaetigtDatum?: string | undefined;
}

export interface GeloeschteWiegungen {
    Personalnummer?: string | undefined;
    FahrzeugKey?: string | undefined;
    Wiegungen?: Wiegedaten[] | undefined;
}

export interface HinweistextLesebestaetigung {
    Typ?: HinweistextLesebestaetigungTyp;
    Personalnummer?: string | undefined;
    PersonalKey?: string | undefined;
    Key?: string | undefined;
    Text?: string | undefined;
}

export enum HinweistextLesebestaetigungTyp {
    Unbekannt = 0,
    FahrerEigenschaft = 1,
    Free02 = 2,
    Free03 = 3,
    Free04 = 4,
    Free05 = 5,
    Free06 = 6,
    Free07 = 7,
    Free08 = 8,
    Free09 = 9,
    Free10 = 10,
    Free11 = 11,
    Free12 = 12,
    Free13 = 13,
    Free14 = 14,
    Free15 = 15,
    Free16 = 16,
    Free17 = 17,
    Free18 = 18,
    Free19 = 19,
}

export interface Empfangsbestaetigung {
    Typ?: EmpfangsbestaetigungElementTyp;
    Key?: string | undefined;
    Status?: EmpfangsbestaetigungStatusTyp | undefined;
}

export enum EmpfangsbestaetigungElementTyp {
    Unbekannt = 0,
    Auftrag = 1,
    Free2 = 2,
    Free3 = 3,
    Free4 = 4,
    Free5 = 5,
    Free6 = 6,
    Free7 = 7,
    Free8 = 8,
    Free9 = 9,
    Free10 = 10,
    Free11 = 11,
    Free12 = 12,
    Free13 = 13,
    Free14 = 14,
    Free15 = 15,
    Free16 = 16,
    Free17 = 17,
    Free18 = 18,
    Free19 = 19,
    Free20 = 20,
}

export enum EmpfangsbestaetigungStatusTyp {
    Unbekannt = 0,
    Empfangen = 1,
    Free2 = 2,
    Free3 = 3,
    Free4 = 4,
    Free5 = 5,
    Free6 = 6,
    Free7 = 7,
    Free8 = 8,
    Free9 = 9,
    Free10 = 10,
    Free11 = 11,
    Free12 = 12,
    Free13 = 13,
    Free14 = 14,
    Free15 = 15,
    Free16 = 16,
    Free17 = 17,
    Free18 = 18,
    Free19 = 19,
    Free20 = 20,
}

export interface Navigationsdaten {
    Adresse?: Adresse | undefined;
    AuftragKey?: string | undefined;
}

export interface AuftragWeiterleitenDaten {
    AuftragKey?: string | undefined;
    VonGeraeteNummer?: string | undefined;
    NachGeraeteNummer?: string | undefined;
    Auftragsnummer?: number;
    Auftragstyp?: Auftragstyp;
}

export interface TextInformationDaten {
    Statuszeit?: string | undefined;
    Typ?: string | undefined;
    Text?: string | undefined;
    Geraet?: string | undefined;
    PersonalKey?: string | undefined;
    Personalnummer?: string | undefined;
    Fahrzeug?: string | undefined;
    FahrzeugKey?: string | undefined;
    Key?: string | undefined;
    IdentNummer?: string | undefined;
    NaechstePruefung?: string | undefined;
    RestTage?: number | undefined;
}

export interface UvvHinweisMeldung {
    Typ?: string | undefined;
    Datum?: string;
    Guid?: string | undefined;
    UvvPruefGegenstand?: UvvPruefGegenstand | undefined;
    Personal?: PersonalRef | undefined;
    Fahrzeug?: FahrzeugRef | undefined;
    Latitude?: number | undefined;
    Longitude?: number | undefined;
}

export interface WiegungInfo {
    Guid?: string | undefined;
    AuftragKey?: string | undefined;
    Auftragsnummer?: number;
    WaageZuordnung?: string | undefined;
    Nummer?: number;
    Datum?: string | undefined;
    Gewicht?: number | undefined;
    WiegeNr?: string | undefined;
    WaageKey?: string | undefined;
    WaageName?: string | undefined;
    WaageMacAdresse?: string | undefined;
    WaageTyp?: string | undefined;
    Einheit?: string | undefined;
    Typ?: WiegungTyp;
    GeraeteNummer?: string | undefined;
    Position?: GpsPosition | undefined;
    PersonalKey?: string | undefined;
    Fahrzeug?: string | undefined;
    FahrzeugKey?: string | undefined;
    AnhaengerKey?: string | undefined;
    Anhaenger?: string | undefined;
    FahrerName?: string | undefined;
    BeifahrerName?: string | undefined;
    Abholadresse?: Adresse | undefined;
    Erzeugeradresse?: Adresse | undefined;
    Auftragsposition?: Auftragsposition | undefined;
}

export interface GpsPositionPush {
    a?: number | undefined;
    b?: number | undefined;
    h?: number | undefined;
    s?: number | undefined;
    u?: number | undefined;
    v?: number | undefined;
    w?: number | undefined;
    p?: string | undefined;
}

export interface AuftragWeiterleitenResult {
    Success?: boolean;
    ErrorMessage?: string | undefined;
}

export interface AuftragWeiterleitenRequest {
    AuftragKey?: string | undefined;
    GeraeteNummer?: string | undefined;
}

export interface GetBerichteRequest {
    PersonalKey?: string | undefined;
    Typ?: string | undefined;
}

export interface GetTourStatusListeRequest {
    FahrzeugKey?: string | undefined;
    Status?: TourStatusTyp;
    Index?: number;
    Count?: number;
}

export interface GetNVEResult {
    NVE?: NVE | undefined;
    ErrorMessage?: string | undefined;
}

export interface GetNVERequest {
    NVE?: string | undefined;
}

export interface NVEMengenmeldungResult {
    Success?: boolean;
    ErrorMessage?: string | undefined;
}

export interface NVEMengenmeldungRequest {
    AuftragKey?: string | undefined;
    Auftragsposition?: Auftragsposition | undefined;
    Mengen?: NVEMenge[] | undefined;
}

export interface NVEMenge {
    NVE?: string | undefined;
    Menge?: number;
}

export interface WiegenRequest {
    WaageKey?: string | undefined;
    Position?: GpsPosition | undefined;
    GeraeteNummer?: string | undefined;
    Auftragsnummer?: number;
    PositionNummer?: number;
    PositionArtikelKey?: string | undefined;
    PositionBezeichnung?: string | undefined;
    Wiegeart?: string | undefined;
    FahrzeugKey?: string | undefined;
    FehrzeugKennzeichen?: string | undefined;
    PersonalKey?: string | undefined;
    Personalnummer?: string | undefined;
    TourKey?: string | undefined;
    TourBezeichnung?: string | undefined;
    Vorname?: string | undefined;
    Nachname?: string | undefined;
}

export interface SucheAdressenResult {
    Success?: boolean;
    ErrorMessage?: string | undefined;
    Adressen?: Adresse[] | undefined;
}

export interface SucheAdressenRequest {
    Suchtext?: string | undefined;
    AdressTyp?: string | undefined;
    Position?: GpsPosition | undefined;
}

export interface SucheBestellungenResult {
    Success?: boolean;
    ErrorMessage?: string | undefined;
    Bestellungen?: Auftrag[] | undefined;
}

export interface SucheBestellungenRequest {
    AdressNummer?: string | undefined;
    DatumVon?: string | undefined;
    DatumBis?: string | undefined;
}

export interface SucheVertraegeResult {
    Success?: boolean;
    ErrorMessage?: string | undefined;
    Vertraege?: Vertrag[] | undefined;
}

export interface SucheVertraegeRequest {
    Suchtext?: string | undefined;
}

export interface AuftragAnlegenResult {
    Auftrag?: Auftrag | undefined;
    Success?: boolean;
    ErrorMessage?: string | undefined;
}

export interface AuftragAnlegenRequest {
    Vertragsnummer?: string | undefined;
    AdressNummer?: string | undefined;
    Auftragstyp?: Auftragstyp;
    TourKey?: string | undefined;
    GeraeteNummer?: string | undefined;
    FahrzeugKennzeichen?: string | undefined;
    FahrzeugKey?: string | undefined;
    PersonalKey?: string | undefined;
    PersonalName?: string | undefined;
    Personalnummer?: string | undefined;
    UnterMandant?: string | undefined;
    Vertragspositionen?: string | undefined;
    Art?: string | undefined;
}

export interface AppLadeTourResult {
    Success?: boolean;
    ErrorMessage?: string | undefined;
}

export interface AppLadeTourRequest {
    TourKey?: string | undefined;
    TourKeys?: string[] | undefined;
}

export interface DokumenteSyncResult {
    dokumente?: Dokument[] | undefined;
}

export interface DokumenteSyncRequest {
    fahrerKey?: string | undefined;
    fahrzeugKey?: string | undefined;
}

export interface AppGetGlasAnalyseListeResult {
    Items?: GlasAnalyse[] | undefined;
    ErrorMessage?: string | undefined;
}

export interface AppGetGlasAnalyseListeRequest {
    Anlage?: string | undefined;
}

export interface UvvSyncResult {
    gegenstaende?: UvvPruefGegenstand[] | undefined;
    kataloge?: UvvKatalog[] | undefined;
    timestamp?: number;
    istVollstaendig?: boolean;
}

export interface UvvSchnellpruefungResult {
    Success?: boolean;
    ErrorMessage?: string | undefined;
    Gegenstand?: UvvPruefGegenstand | undefined;
}

export interface UvvSchnellpruefungRequest {
    Gegenstand?: UvvPruefGegenstand | undefined;
}

export interface ExportMessage extends DefaultEntity {
    mandantId?: string | undefined;
    Guid?: string | undefined;
    Status?: MessageStatus;
    Type?: MessageType;
    Data?: string | undefined;
    Dateiname?: string | undefined;
    UnterMandant?: string | undefined;
    GridFsId?: string | undefined;
    ExternesSystemId?: string | undefined;
}

export enum MessageStatus {
    Initial = 0,
    Gesendet = 1,
    Verarbeitet = 2,
    Fehler = 3,
    WarteAufAck = 4,
}

export enum MessageType {
    Textdatei = 0,
}

export interface GeoAdresse extends DefaultEntity {
    Name1?: string | undefined;
    Name2?: string | undefined;
    Strasse?: string | undefined;
    PLZ?: string | undefined;
    Ort?: string | undefined;
    LKZ?: string | undefined;
    Longitude?: number | undefined;
    Latitude?: number | undefined;
    anzahlGeocodingVersuche?: number;
    GeocodingStatus?: string | undefined;
    Mandant?: string | undefined;
}

export interface Geocode2Request {
    Text?: string | undefined;
}

export interface FileParameter {
    data: any;
    fileName: string;
}

export interface FileResponse {
    data: Blob;
    status: number;
    fileName?: string;
    headers?: { [name: string]: any };
}